{
  "schemaVersion": 2,
  "source": {
    "schemaVersion": 3,
    "gameDataVersion": "compiled-sha256-ae94f46a61e6c332",
    "buildId": "public-v3-sha256-bd683f5f9c6f2e2d",
    "generatedAt": "2026-09-23T16:37:37Z"
  },
  "filters": {
    "realms": [
      "AEQUOR",
      "CARO",
      "CHAOS",
      "ULTRA"
    ],
    "wheelMainstats": [
      "ALIEMUS_REGEN",
      "CRIT_DMG",
      "CRIT_RATE",
      "DEATH_RESISTANCE",
      "DMG_AMP",
      "KEYFLARE_REGEN",
      "REALM_MASTERY",
      "SIGIL_YIELD"
    ],
    "wheelRarities": [
      "N",
      "R",
      "SR",
      "SSR"
    ],
    "posseRealms": [
      "AEQUOR",
      "CARO",
      "CHAOS",
      "FADED_LEGACY",
      "OTHER",
      "ULTRA"
    ]
  },
  "entities": {
    "awakeners": [
      {
        "id": "awakener-0001",
        "kind": "awakener",
        "name": "\"24\"",
        "lineupToken": "S",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/mason.webp",
          "full": "./generated-assets/awk-cards/mason.webp"
        },
        "description": "In solitude, one must act as a team. The twenty-four minds are crowded together—they whisper and chuckle in the dark, tearing at 24's soul, craving to devour her.\n\nThe stench from the corner sewer, the cotton drifting through the workshop, the stale black bread... The past has long faded, and no one remembers the ordinary worker from the East District. She has finally shed her weary body, only to step into a new quagmire.",
        "aliases": [
          "24",
          "twenty-four"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Bleed",
          "Counter",
          "STR Up",
          "STR Down",
          "Tentacle DMG",
          "Pierce DMG",
          "Arithmetica",
          "Hand Limit",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0002",
        "kind": "awakener",
        "name": "Agrippa",
        "lineupToken": "R",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/agrippa.webp",
          "full": "./generated-assets/awk-cards/agrippa.webp"
        },
        "description": "Until the fury of history burned everything away, Agrippa was the brightest jewel in Capua.\nShe does as she likes, and her whip always comes down hard on the silent gladiators. She hates being looked at straight on—it lays bare the weakness underneath. But when it comes to breaking in a slave, Agrippa is a professional. Perhaps you'd care to inspect the twenty whips of assorted design in her bedroom. She had them prepared especially for you.",
        "aliases": [
          "agrippa"
        ],
        "searchTags": [
          "Poison",
          "Alert",
          "STR Up",
          "Draw",
          "Spider"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0003",
        "kind": "awakener",
        "name": "Aigis",
        "lineupToken": "I",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/aigis.webp",
          "full": "./generated-assets/awk-cards/aigis.webp"
        },
        "description": "Do not come close. Do not touch. Do not look at her directly. Do not pity her. Perhaps some creatures were only ever meant to live alone in the dark.\nIt is not what she wants. But if her frail body, her timid voice, her childish clothes move you to look tenderly into her eyes, you will fall into stillness and silence forever.",
        "aliases": [
          "aigis"
        ],
        "searchTags": [
          "Vulnerable",
          "Stun",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0004",
        "kind": "awakener",
        "name": "Alva",
        "lineupToken": "F",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/alva.webp",
          "full": "./generated-assets/awk-cards/alva.webp"
        },
        "description": "Alva is very happy with her prosthetic.\n\"After that battle, I never expected to stand again. Getting another chance to fight for what's right is an honor.\"\nAs for the low moans that come from her room at midnight—once the sun clears the horizon, let them be as if they never happened.",
        "aliases": [
          "alva"
        ],
        "searchTags": [
          "Vulnerable",
          "Alert",
          "Dispel",
          "Death Resistance",
          "Discard",
          "Draw",
          "Strike"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0005",
        "kind": "awakener",
        "name": "Aurita",
        "lineupToken": "n",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/aurita.webp",
          "full": "./generated-assets/awk-cards/aurita.webp"
        },
        "description": "An ocean spirit who once faced demise in solitude has found a miraculous second life on land.\n\nWhether naturally optimistic or choosing to forget to escape suffering, her guileless innocence exudes an irresistible charm that draws people to her side—perhaps this is a subtle ploy of hers to expand her \"circle of friends.\"",
        "aliases": [
          "aurita"
        ],
        "searchTags": [
          "STR Up",
          "Tentacle DMG",
          "Pierce DMG",
          "Aftershock",
          "Discard",
          "Draw",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0006",
        "kind": "awakener",
        "name": "Caecus",
        "lineupToken": "L",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/caecus.webp",
          "full": "./generated-assets/awk-cards/caecus.webp"
        },
        "description": "He is always scowling, always drifting along the lakeshore alone. Bit by bit the students have taken to calling that stretch of water \"the gloomy half-Deep One's territory.\" So he comes every day and patrols it, solemn as any lord. When he throws himself in, the churning bubbles wrap around him gently; down there, the jeering from the bank is hard to make out.",
        "aliases": [
          "caecus"
        ],
        "searchTags": [
          "Vulnerable",
          "Counter",
          "STR Up",
          "Tentacle DMG",
          "Dispel",
          "Heal",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0007",
        "kind": "awakener",
        "name": "Casiah",
        "lineupToken": "m",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/casiah.webp",
          "full": "./generated-assets/awk-cards/casiah.webp"
        },
        "description": "Let’s dance! Dance a merry dance, dance a wild dance! Laugh along with her, and stoke the atmosphere to fever pitch.\n\nAnd then—it's time for the star to take the stage.\n\nThere, where the spotlights converge, the mad magician has already slipped her hand into her top hat. As for what she will pull from that endless void—be it a cascade of colorful ribbons, a flock of white doves taking flight, or the razor-sharp claws of some dreadful monster... I'm afraid only she can tell.",
        "aliases": [
          "casiah"
        ],
        "searchTags": [
          "STR Up",
          "Aftershock",
          "Arithmetica",
          "Discard",
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0008",
        "kind": "awakener",
        "name": "Castor",
        "lineupToken": "6",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/castor.webp",
          "full": "./generated-assets/awk-cards/castor.webp"
        },
        "description": "If born into an ordinary family, Castor might have grown into a modest young man as warm and steady as a tree. But now, he is the only one among the twins who retained a complete body and soul; he remains silent like a stone, waiting to bury that ember the two of them shared in their youth deep within, never giving up, never wavering.\nThose already matured wings, capable of stirring up a storm, are now retracted in dormancy, as a bird quietly awaits the moment the cage door opens to once again soar in the sky.",
        "aliases": [
          "castor"
        ],
        "searchTags": [
          "Weakness",
          "Corrosion",
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0009",
        "kind": "awakener",
        "name": "Celeste",
        "lineupToken": "g",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/celeste.webp",
          "full": "./generated-assets/awk-cards/celeste.webp"
        },
        "description": "Her ethereal beauty is always reminiscent of the bird of heaven, spreading its glossy wings towards utopia as her white dress flutters with caressing breezes.\n\nHowever, does the girl who perches on the mast ever imagine herself flying in the azure sky?",
        "aliases": [
          "celeste"
        ],
        "searchTags": [
          "Weakness",
          "Tentacle DMG",
          "Dispel",
          "Arithmetica",
          "Heal",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0010",
        "kind": "awakener",
        "name": "Clementine",
        "lineupToken": "8",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/clementine.webp",
          "full": "./generated-assets/awk-cards/clementine.webp"
        },
        "description": "Everyone wears a mask; she chose the one that numbs the heart best—\n\nShe smiles gently, she speaks gently, and every look and every word lands exactly where it needs to, until the patients who come to her for counseling believe with all their hearts that they have found the one person who understands them, the one who will show them the way.\nThat is enough.\n\nA moth doomed to burn does not need to know how it ends. It only needs to keep following where she leads.\n\nAnd inside that warmth that looks so much like salvation, the fire takes hold, and there is no turning back.",
        "aliases": [
          "clementine"
        ],
        "searchTags": [
          "Bleed",
          "STR Up",
          "STR Down",
          "Dispel",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0011",
        "kind": "awakener",
        "name": "Corposant",
        "lineupToken": "5",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/corposant.webp",
          "full": "./generated-assets/awk-cards/corposant.webp"
        },
        "description": "She is the flag that flutters high as the ship sails, guiding its course; she is also the dirge that holds to its duty until the very last moment, when the ship sinks beneath the waves.\n\nHer responsibility, her duty, her life—all are bound to the ship; nothing else remains.\n\nFor guiding the course is the very meaning of her existence.",
        "aliases": [
          "corposant"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "STR Up",
          "Tentacle DMG",
          "Aftershock",
          "Death Resistance",
          "Discard",
          "Draw",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0012",
        "kind": "awakener",
        "name": "Daffodil",
        "lineupToken": "H",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/daffodil.webp",
          "full": "./generated-assets/awk-cards/daffodil.webp"
        },
        "description": "\"Welcome to Lady Daffodil's Exchange Shop. We barter goods and collect heads. Our rates are perfectly fair—fair to all, no deception.\"\n\nAmidst the swirling gray mist, the woman gently tapped the ash from her antique wooden pipe. Beneath the swaying brim of her hat, a flickering smile hovered at the corners of her lips, laced with ambiguity.",
        "aliases": [
          "daffodil"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Counter",
          "STR Up",
          "Pierce DMG",
          "Arithmetica",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0013",
        "kind": "awakener",
        "name": "Doll",
        "lineupToken": "k",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/doll.webp",
          "full": "./generated-assets/awk-cards/doll.webp"
        },
        "description": "Flasks must be washed until they look new. A bench scorched in an experiment must be sanded until it shines. The balance is recalibrated every third day. Her zeal and reverence for science, for the secrets of the world, make her expect as much from everyone and everything around her.\nHerself included, of course—after all, not everyone can embrace death calmly and ask to be made an Awakener.",
        "aliases": [
          "doll"
        ],
        "searchTags": [
          "Weakness",
          "Dispel",
          "Discard",
          "Heal"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SR",
        "type": "CHORUS",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0014",
        "kind": "awakener",
        "name": "Doresain",
        "lineupToken": "xg",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/doresain.webp",
          "full": "./generated-assets/awk-cards/doresain.webp"
        },
        "description": "The founder of Necrovia, the eternal king of ghouls. \n\nHis banquet is worthy of the deepest anticipation—grand dining hall, elegant dance, and those exquisite dishes handcrafted from corpses will surely be unforgettable for your entire life.",
        "aliases": [
          "doresain"
        ],
        "searchTags": [
          "Vulnerable",
          "STR Up",
          "Pierce DMG",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0015",
        "kind": "awakener",
        "name": "Erica",
        "lineupToken": "U",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/erica.webp",
          "full": "./generated-assets/awk-cards/erica.webp"
        },
        "description": "Doll once studied her in exhaustive detail, but nowhere—not the torso, not the limbs, not the skull, not the pelvic cavity—was there any part capable of producing sound. How she speaks at all has become one of Mythag's countless unsolved mysteries.\nMost of the time she can hold an ordinary conversation. Now and then, though, that mysterious voice seems to have a will of its own, and what it says makes the skin crawl and the blood run cold.",
        "aliases": [
          "erica"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Alert",
          "STR Up",
          "Dispel",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0016",
        "kind": "awakener",
        "name": "Faint",
        "lineupToken": "r",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/faint.webp",
          "full": "./generated-assets/awk-cards/faint.webp"
        },
        "description": "Faint is a faded, hard-to-hatch seed.\n\nPeople pity her for her flaws and love her for her weaknesses.\n\nYet those who knew she had chosen to remain in the shell, had long since turned to dust—stardust.",
        "aliases": [
          "faint"
        ],
        "searchTags": [
          "Weakness",
          "Counter",
          "STR Up",
          "STR Down",
          "Steal STR",
          "Dispel",
          "Death Resistance",
          "Heal"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0017",
        "kind": "awakener",
        "name": "Faros",
        "lineupToken": "p",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/faros.webp",
          "full": "./generated-assets/awk-cards/faros.webp"
        },
        "description": "Beware: a siren's mesmerizing charm lurks under her seemingly calm and rational words. Never show curiosity towards the unique appearance beneath her malformed helmet; never forget her long-lasting dissatisfaction with this humanoid body.\n\nHer gleaming light once lured moths to its molten warmth. Her burning fire once guided the lost to their doom. Now, only confusion flickers in her lighthouse.",
        "aliases": [
          "faros"
        ],
        "searchTags": [
          "Poison",
          "Tentacle DMG",
          "Dispel",
          "Arithmetica",
          "Draw",
          "Hand Limit",
          "Lemurian",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0018",
        "kind": "awakener",
        "name": "Doll: Inferno",
        "lineupToken": "T",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/doll-inferno.webp",
          "full": "./generated-assets/awk-cards/doll-inferno.webp"
        },
        "description": "Genius and madness are a hair apart. She was once the brightest mind Mythag had, and her fall came like a great tower coming down; out of the rubble of all that reason crawled nothing but a raving fiend.\nShe still puts on the vestments of science as she always did, pouring life, humanity, love, and ruin into the crucible, cooking up a poison to destroy the world.",
        "aliases": [
          "doll: inferno",
          "g-doll"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Arithmetica",
          "Draw",
          "Heal",
          "Max HP DMG",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "Genesis",
        "type": "CHORUS",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0019",
        "kind": "awakener",
        "name": "Helot: Catena",
        "lineupToken": "h",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/helot-catena.webp",
          "full": "./generated-assets/awk-cards/helot-catena.webp"
        },
        "description": "Her memory has been steeped in blood since the day she was taken to prison. \nWhatever was ordinary and warm before feels like a lying dream now, blurred and split apart, driven into her flesh as so many sharp pieces. \nShe can't recall the gentle arms or the worried face anymore; all that stays in her is hatred, and a question, and no end to either. \nPain, humiliation, betrayal... what was any of it for? \nShe asked, day after day, and no one ever answered, right up to the day freedom came. \nSo she will find the answer herself: she will put the question to every filthy heart, one at a time, tearing it from the wailing, screaming chest that holds it.",
        "aliases": [
          "helot: catena",
          "g-helot"
        ],
        "searchTags": [
          "Bleed",
          "STR Up",
          "Draw",
          "Hand Limit",
          "Heal",
          "Self-Damage",
          "Strike"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "Genesis",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0020",
        "kind": "awakener",
        "name": "Ramona: Timeworn",
        "lineupToken": "i",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/ramona-timeworn.webp",
          "full": "./generated-assets/awk-cards/ramona-timeworn.webp"
        },
        "description": "She calculated the speed of a sword stroke, the angle that would carry her clear of a blow.\nShe calculated whether an escape plan could work, and the odds that the world still had a future to reach.\nRight to the very end, she never gave up the arithmetic.\nJust as she never gave up walking that road where no one else walked.",
        "aliases": [
          "ramona: timeworn",
          "g-ramona"
        ],
        "searchTags": [
          "STR Up",
          "STR Down",
          "Arithmetica",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "Genesis",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0021",
        "kind": "awakener",
        "name": "Goliath",
        "lineupToken": "e",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/goliath.webp",
          "full": "./generated-assets/awk-cards/goliath.webp"
        },
        "description": "He is but a giant. His silhouette awing, his power indestructible. His weapon a colossal blade that no one else can lift. His victories, gleaming like oiled fur on the blade's fang, nourished by countless wars and savage sacrifices. His prize, a mountain of heads severed from his enemies and kin, crowned only by his own head on top.",
        "aliases": [
          "goliath"
        ],
        "searchTags": [
          "STR Up",
          "Tentacle DMG",
          "Dispel",
          "Lemurian",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0022",
        "kind": "awakener",
        "name": "Hameln",
        "lineupToken": "X",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/hameln.webp",
          "full": "./generated-assets/awk-cards/hameln.webp"
        },
        "description": "At first glance, Hameln always reminded you of a kind of Eastern porcelain—white, luxurious, with graceful curves and a wave-like gentle sheen, yet somewhat cold to the touch.\n\nBeneath that respectable, meticulous exterior lies a soul of extreme, empty purity. His entire life revolved around a single thought, like a machine programmed with one command, devoid of all other responses.\n\nTo him, everything was merely a sequence of musical notes.\n\nPlay, play, endlessly play.",
        "aliases": [
          "hameln"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Bleed",
          "STR Up",
          "STR Down",
          "Pierce DMG",
          "Arithmetica"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0023",
        "kind": "awakener",
        "name": "Helot",
        "lineupToken": "E",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/helot.webp",
          "full": "./generated-assets/awk-cards/helot.webp"
        },
        "description": "She was not born thirsting for blood. Once, she basked in warmth as fervent and fleeting as a night-blooming epiphyllum. Betrayal and imprisonment fanned the flames of her defiance; the fire of vengeance soon scorched Maysia. Steeped in endless resentment, she has since shuttered her heart to all...",
        "aliases": [
          "helot"
        ],
        "searchTags": [
          "Dispel",
          "Discard",
          "Draw",
          "Hand Limit",
          "Self-Damage",
          "Strike"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0024",
        "kind": "awakener",
        "name": "Horla",
        "lineupToken": "A",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/horla.webp",
          "full": "./generated-assets/awk-cards/horla.webp"
        },
        "description": "A rose thorn tears the page of the poem and leaves a colorless smear of blood. The smell of alcohol drifts and lingers; invisible flames spread in every direction.\nInside that fire, Horla holds the last canto in her hands, writing a silent footnote to the end of the genius poet who hid herself away in the greenhouse.",
        "aliases": [
          "horla"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Counter",
          "STR Up",
          "STR Down",
          "Death Resistance",
          "Heal"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0025",
        "kind": "awakener",
        "name": "Jenkin",
        "lineupToken": "K",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/jenkin.webp",
          "full": "./generated-assets/awk-cards/jenkin.webp"
        },
        "description": "Everyone quickly accepted one fact: where there's Jenkin, there's Brown, and where there's Brown, there's Jenkin. And whenever Brown acted alone—make no mistake—Jenkin was behind it.\n\n\"What do you mean by 'stolen'? I have an alibi!\"\n\nSo said the girl, holding the item Brown had \"borrowed.\"",
        "aliases": [
          "jenkins"
        ],
        "searchTags": [
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0026",
        "kind": "awakener",
        "name": "Karen",
        "lineupToken": "l",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/karen.webp",
          "full": "./generated-assets/awk-cards/karen.webp"
        },
        "description": "\"I want to wear purple crystals as black as wine.\" \n\n\"I want to don a luxurious gown made of ostrich feathers.\" \n\n\"I want to be the only light at the banquet.\" \n\nThe maid blinked her amber eyes. She had many more beautiful wishes, but she could no longer voice them. Before her frozen body loomed an endless green flame, silently blooming in the dark night.",
        "aliases": [
          "karen"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Dispel",
          "Arithmetica",
          "Draw",
          "Heal",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0027",
        "kind": "awakener",
        "name": "Kathigu-Ra",
        "lineupToken": "Z",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/kathigu-ra.webp",
          "full": "./generated-assets/awk-cards/kathigu-ra.webp"
        },
        "description": "Kathigu-Ra excels at using her signature smile to draw out the cruel, crazed chill that lurks in the deepest reaches of any observer's awareness.\n\nThose two inseparable twin guns, with powder dust swirling around their barrels, warn every ill-intentioned petty criminal that the sacrifice of the nameless is the cornerstone of all greatness.\n\nHowever, anyone who has truly dealt with her will understand that hunting these ordinary, sunless people is merely her pastime during the tedium of daily life.\n\nAfter all, when she truly opens fire, the barrels hold no gunpowder at all.",
        "aliases": [
          "kathigu-ra",
          "kathigura"
        ],
        "searchTags": [
          "STR Up",
          "Pierce DMG",
          "Dispel",
          "Discard",
          "Draw"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0028",
        "kind": "awakener",
        "name": "Leigh",
        "lineupToken": "O",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/leigh.webp",
          "full": "./generated-assets/awk-cards/leigh.webp"
        },
        "description": "Shh... Don't be afraid. It's just the sound of rats decaying in the damp cellar. From the deepest abyss, a crimson desire festers. The imprisoned soul yearns for blood, just as the blind long for light and the lecherous thirst for flesh. And the way to please her is quite simple: lash out at her and humiliate her to your heart's content.",
        "aliases": [
          "leigh"
        ],
        "searchTags": [
          "STR Up",
          "Pierce DMG",
          "Dispel",
          "Heal",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0029",
        "kind": "awakener",
        "name": "Lily",
        "lineupToken": "v",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/lily.webp",
          "full": "./generated-assets/awk-cards/lily.webp"
        },
        "description": "Yearning for an entity she calls \"Mommy\", this girl obediently follows the commands of her \"Master\".\n\nHer true name lost to the world, she is now known only by the form she inhabits: a delicate white filament, reminiscent of a lily, blooming at the center of a giant black eyeball made of sludge. Hence, they named her Lily.",
        "aliases": [
          "lily"
        ],
        "searchTags": [
          "Poison",
          "Death Resistance",
          "Heal",
          "Strike"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0030",
        "kind": "awakener",
        "name": "Liz",
        "lineupToken": "c",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/liz.webp",
          "full": "./generated-assets/awk-cards/liz.webp"
        },
        "description": "She dances within the embrace of green flames, their dim flickering light falling across the dancer's young, devotion-filled face. With every turn, the emerald fire ignites the souls of the wicked, burning away every impurity upon the stage.",
        "aliases": [
          "liz"
        ],
        "searchTags": [
          "Poison",
          "STR Up",
          "Pierce DMG",
          "Discard",
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0031",
        "kind": "awakener",
        "name": "Lotan",
        "lineupToken": "j",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/lotan.webp",
          "full": "./generated-assets/awk-cards/lotan.webp"
        },
        "description": "Lotan has so many labels attached to her that no one knows how to approach this black-clad swordswoman.\n\nToo humble and she will shatter your knees for being too boring; too arrogant and she will slash your insolence with her greatsword; too tough and she will soften your soul through battle.\n\nBut perhaps this is the arrogance befitting one born with the planet itself. As a former guardian, she has every right to her arrogance.",
        "aliases": [
          "lotan"
        ],
        "searchTags": [
          "STR Up",
          "Dispel",
          "Max HP DMG",
          "Strike"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SR",
        "type": "ASSAULT",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0032",
        "kind": "awakener",
        "name": "Miryam",
        "lineupToken": "w",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/miryam.webp",
          "full": "./generated-assets/awk-cards/miryam.webp"
        },
        "description": "Black veils, and beneath the robes Miryam's body, worn down to the bone.\nShe makes no sound. Devotion and grief are woven together in her face, like a Madonna in a mural, heavy with a mystery no one can read.\nEverything she has, she pours into waiting for one particular moment.\nIt is close now. The appointed day is almost here...",
        "aliases": [
          "miryam"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "STR Up",
          "STR Down",
          "Tentacle DMG",
          "Pierce DMG",
          "Arithmetica",
          "Draw",
          "Heal",
          "Lemurian",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0033",
        "kind": "awakener",
        "name": "Mouchette",
        "lineupToken": "xf",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/mouchette.webp",
          "full": "./generated-assets/awk-cards/mouchette.webp"
        },
        "description": "Strictly speaking, she does not belong to this world on the brink of collapse, but she appreciates it.\n\nShe admires the magnificent spectacle of this world burning, appreciates the suffering and breakdown of these humans in despair.\n\nFaith is dead, society has come to a halt, morals have crumbled, and nature no longer needs to disguise itself as a boring \"normal person\" —\nshe can finally unleash the beast within her and reveal her true self, becoming her authentic self.",
        "aliases": [
          "mouchette"
        ],
        "searchTags": [
          "Stun",
          "Pursuit",
          "Death Resistance",
          "Strike"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0034",
        "kind": "awakener",
        "name": "Murphy",
        "lineupToken": "q",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/murphy.webp",
          "full": "./generated-assets/awk-cards/murphy.webp"
        },
        "description": "Proud, willful, self-centered... Many who have interacted with her would describe her personality as such. She seems to have always been treated like the center of the universe in her last living arrangement; perhaps it was this meticulous care that cultivated her spoiled nature.\n\n\"Hey! What are you looking at? Didn't I say that if I call you three times, you have to respond to this young lady?!\"\n\n—One must be very careful, even when reading the documents.",
        "aliases": [
          "murphy"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Tentacle DMG",
          "Aftershock",
          "Dispel",
          "Arithmetica",
          "Keyflare",
          "Tentacle Generation",
          "Sacrifice"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0035",
        "kind": "awakener",
        "name": "Murphy: Fauxborn",
        "lineupToken": "G",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/murphy-fauxborn.webp",
          "full": "./generated-assets/awk-cards/murphy-fauxborn.webp"
        },
        "description": "She always arrogantly refers to herself as the \"Divine Mother,\" coldly and hostilely keeping everyone outside her safe perimeter. It's difficult for those meeting her for the first time to connect her with the spoiled little princess.\n\n\"But they are essentially the same person,\" the Keeper, however, stubbornly insists to everyone. \"You'd know if you ever saw her wolf down a cupcake alone.\"",
        "aliases": [
          "murphy: fauxborn",
          "g-murphy"
        ],
        "searchTags": [
          "Tentacle DMG",
          "Aftershock",
          "Dispel",
          "Arithmetica",
          "Divine Realm",
          "Draw",
          "Keyflare",
          "Lemurian",
          "Tentacle Generation",
          "Sacrifice"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "Genesis",
        "type": "CHORUS",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0036",
        "kind": "awakener",
        "name": "Nautila",
        "lineupToken": "f",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/nautila.webp",
          "full": "./generated-assets/awk-cards/nautila.webp"
        },
        "description": "She always seems to be circling that motorcycle of hers, the \"Phantom\"—a screw tightened here, a line adjusted there. The work has no end to it. Plenty of people tell her the repairs could not possibly be better, and still she buries herself in it, day after day.\nThe reason is a feeling she cannot account for: that something is still missing.",
        "aliases": [
          "nautila"
        ],
        "searchTags": [
          "Counter"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0037",
        "kind": "awakener",
        "name": "Nymphaea",
        "lineupToken": "u",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/nymphaea.webp",
          "full": "./generated-assets/awk-cards/nymphaea.webp"
        },
        "description": "The body this will projects still keeps the shape of a girl who died too young. Rotting hems, pale skin, eyes clouded with the shade of a former life—without a word, they tell of a past tangled up in sickness and suffering.",
        "aliases": [
          "nymphaea"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "STR Up"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0038",
        "kind": "awakener",
        "name": "Ogier",
        "lineupToken": "C",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/ogier.webp",
          "full": "./generated-assets/awk-cards/ogier.webp"
        },
        "description": "Every word he speaks is an act of loyalty; every move he makes, an act of virtue.\nThough courtesy, honor, and self-discipline are carved deep into his soul, this Virtue Knight still wears the face of a child.\nBut there's no need to worry. Even if the price is being erased forever, Ogier will give everything he has to carry out his lord's orders.\nMay that day never come.",
        "aliases": [
          "ogier"
        ],
        "searchTags": [
          "Vulnerable",
          "STR Up",
          "Pierce DMG",
          "Dispel"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SR",
        "type": "WARDEN",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0039",
        "kind": "awakener",
        "name": "Pandia",
        "lineupToken": "b",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/pandia.webp",
          "full": "./generated-assets/awk-cards/pandia.webp"
        },
        "description": "Sweet laughter like a silver bell rings hollow, and a small body takes shape in the failing candlelight. She is the terror and the longing of the guilty, sweet rain and poisoned wine to the dying, bringing sweet pain and romantic madness. The crack of the whip that never leaves her hand, landing on bare flesh, is the wicked music of the dark.",
        "aliases": [
          "pandia"
        ],
        "searchTags": [
          "Vulnerable",
          "Counter",
          "STR Up"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0040",
        "kind": "awakener",
        "name": "Pickman",
        "lineupToken": "9",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/pickman.webp",
          "full": "./generated-assets/awk-cards/pickman.webp"
        },
        "description": "A half-human, half-ghoul artist, he possesses an otherworldly talent that remains forever out of reach for ordinary souls.\n\nHis ghoul artworks dissolve the fragile boundary between the painted world and the real one, pulling viewers into a total, and often terrifying, immersion.\n\nYet Pickman vehemently rejects the title of mad surrealist.\n\nIn his own declaration, he has always been, and will only ever be, a realist—for he paints nothing but the world as it truly is.",
        "aliases": [
          "pickman"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "STR Up",
          "Steal STR",
          "Discover",
          "Arithmetica",
          "Draw"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0041",
        "kind": "awakener",
        "name": "Pollux",
        "lineupToken": "2",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/pollux.webp",
          "full": "./generated-assets/awk-cards/pollux.webp"
        },
        "description": "He is flesh born from a twisted existence, made up of cut and resewn skin, an empty chest cavity, a tainted heart, and invisible chains.\nHe is placed on a pedestal; people worship at his feet and claim he possesses a pure soul.\n\nWhat exactly is he? Lost in countless dreams, he asks in confusion; among the dark green lake water and the empty fog, only his voice echoes in loneliness.",
        "aliases": [
          "pollux"
        ],
        "searchTags": [
          "Bleed",
          "Discard",
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Hybrid"
      },
      {
        "id": "awakener-0042",
        "kind": "awakener",
        "name": "Ramona",
        "lineupToken": "M",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/ramona.webp",
          "full": "./generated-assets/awk-cards/ramona.webp"
        },
        "description": "The keeper of the Awakener records has moved her file to the Student Administration Office more than once, and every time she has carried it back herself, to be buried again under the mountains of paperwork.\n\"Just leave it here. It'll have to go over eventually.\"\nHer voice is as calm as ever. Her eyes are not.\n\nWhat kind of storm is she keeping under all that calm?",
        "aliases": [
          "ramona"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "STR Up",
          "STR Down",
          "Arithmetica",
          "Discard",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0043",
        "kind": "awakener",
        "name": "Ryker",
        "lineupToken": "V",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/ryker.webp",
          "full": "./generated-assets/awk-cards/ryker.webp"
        },
        "description": "Ryker is known as the \"Lucky Detective\" by his detective friends.\n\nAs the name suggests, he is a lucky person: whenever he places a bet, he wins ten times the stake; whenever he guesses, he chooses the right answer.\n\nThe \"Lucky Detective\" doesn't have to be an actual detective; he‘s solved many cases by chance alone, so he was embraced on this path.\n\nHe doesn't solve cases by deduction, relying on luck instead. Just a tour around the crime scene and he stumbles upon the culprit; just walking along the road, he picks up key evidence.\n\nWith such good fortune, he's lived out a smooth twenty-five years.\n\nHe never worries about yesterday, nor frets about tomorrow.",
        "aliases": [
          "ryker"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "STR Up",
          "Arithmetica",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0044",
        "kind": "awakener",
        "name": "Salvador",
        "lineupToken": "Q",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/salvador.webp",
          "full": "./generated-assets/awk-cards/salvador.webp"
        },
        "description": "You need not fear his black eye patch; the smothering darkness will not obscure his boundless compassion. The sightless body may have perished, yet the will for redemption endures. Before him, everything should be loved, and everything will be loved in turn.\n\nThe words of the Our Father are forever engraved onto the Tablet, and through these blessed flesh and bones, He will bestow upon you \"The Blessing\".",
        "aliases": [
          "salvador"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Barrier",
          "STR Up",
          "Heal",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0045",
        "kind": "awakener",
        "name": "Sanga",
        "lineupToken": "J",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/sanga.webp",
          "full": "./generated-assets/awk-cards/sanga.webp"
        },
        "description": "The artist from Cité cares not for other people. She only pursues the absolute form of pure beauty, etching ephemeral moments into eternity.\n\nAs her inspiration surges forth, her chisel never ceases; as her works witness completion, her body is submerged in coral-colored shades. In the corner of her workshop which she pays no heed, her agony and delight intertwine, sprouting from her very existence.",
        "aliases": [
          "sanga"
        ],
        "searchTags": [
          "Tentacle DMG",
          "Aftershock",
          "Dispel",
          "Death Resistance",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0046",
        "kind": "awakener",
        "name": "Sorel",
        "lineupToken": "B",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/sorel.webp",
          "full": "./generated-assets/awk-cards/sorel.webp"
        },
        "description": "A silver tongue is the nectar of a rosebud; lords and courtiers, the bees and butterflies that dance around its swaying bloom.\n\nThe thorns fed by desire have crept up on the rose window, coiling tightly around it.\n\nPeople may gossip behind her back, and the crown may leave her hands torn and bleeding, but she will never relinquish the power she has drawn into her arms.\n\nAfter all, this is the nourishment a rose truly needs to bloom.",
        "aliases": [
          "sorel"
        ],
        "searchTags": [
          "STR Up",
          "Death Resistance",
          "Heal",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0047",
        "kind": "awakener",
        "name": "Tawil",
        "lineupToken": "W",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/tawil.webp",
          "full": "./generated-assets/awk-cards/tawil.webp"
        },
        "description": "Tawil does not exist in the current world. Their existence would draw the attention of the 'Supreme Will,' so They cannot and must not exist. Wisdom and silence are all The Gatekeeper can offer to these tireless seekers. In Their daily vigil, Tawil quietly bestows Their wisdom, courage, and silent blessings upon the fate of humanity.",
        "aliases": [
          "tawil"
        ],
        "searchTags": [
          "Barrier",
          "STR Up",
          "Pierce DMG",
          "Arithmetica",
          "Discard",
          "Draw",
          "Keyflare",
          "Max HP DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Gateway"
      },
      {
        "id": "awakener-0048",
        "kind": "awakener",
        "name": "Thais",
        "lineupToken": "N",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/thais.webp",
          "full": "./generated-assets/awk-cards/thais.webp"
        },
        "description": "Draped in shimmering jewels and trailing gossamer silk, she keeps her true self hidden beneath a facade of breathtaking splendor.\n\nThais may appear vain and frivolous—an impression held by many—but perhaps that is merely another mask she wears.\n\n\"My, what are you writing there? Here, let me help—",
        "aliases": [
          "thais"
        ],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Poison",
          "Bleed",
          "Counter",
          "STR Up",
          "Arithmetica",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0049",
        "kind": "awakener",
        "name": "Tinct",
        "lineupToken": "o",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/tinct.webp",
          "full": "./generated-assets/awk-cards/tinct.webp"
        },
        "description": "She is the singer among the stars, the shimmering stardust.\n\nShe is the bird trapped in a gilded cage, the discarded phonograph.\n\nWhen her home planet collapse into the void, she is compelled to embrace the hope of life, becoming a wanderer in the unclaimed depths of space, an eternal seeker singing in search of home.\n\n\"Sister... Though I am the one who can walk freely among us, you have always been the one supporting me.\"",
        "aliases": [
          "tinct"
        ],
        "searchTags": [
          "STR Up",
          "Steal STR",
          "Dispel",
          "Arithmetica",
          "Draw",
          "Strike"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0050",
        "kind": "awakener",
        "name": "Tulu",
        "lineupToken": "d",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/tulu.webp",
          "full": "./generated-assets/awk-cards/tulu.webp"
        },
        "description": "The young King slumbers upon his throne. Upon waking, he issues his decrees, his authority reaching every corner of the world.\n\nYet before the sun has set, the King is already weary. He has grown tired of his own power and transcendent wisdom; tired of the fanatical worship of his followers, and of the long dreams that have stretched across aeons.\n\nNone know what he witnessed during his long sleep, but they should be grateful for the bliss of their own ignorance.",
        "aliases": [
          "tulu"
        ],
        "searchTags": [
          "STR Up",
          "STR Down",
          "Tentacle DMG",
          "Pierce DMG",
          "Aftershock",
          "Dispel",
          "Lemurian",
          "Tentacle Generation"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Out of the Aeons"
      },
      {
        "id": "awakener-0051",
        "kind": "awakener",
        "name": "Uvhash",
        "lineupToken": "P",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/uvhash.webp",
          "full": "./generated-assets/awk-cards/uvhash.webp"
        },
        "description": "How could we ever forget the hero Uvhash? He was the finest of men. The warrior fell to his knees in the sunset-drenched sands, his body bathed in warm blood. Vultures circled above, singing his dirge:\n<Italic:No tears shall honor you, no weeping shall lay you to rest,\nFor in life, your name had already conquered Rome.>",
        "aliases": [
          "uvhash"
        ],
        "searchTags": [
          "STR Up",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "Outlanders"
      },
      {
        "id": "awakener-0052",
        "kind": "awakener",
        "name": "Wanda",
        "lineupToken": "D",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/wanda.webp",
          "full": "./generated-assets/awk-cards/wanda.webp"
        },
        "description": "Wanda is clever, rich, and beautiful, and as she says herself, she lives to enjoy herself. She makes men her slaves, then sets her feet, cold as moonlight, on their backs. Venus in her laurel crown, she is evil and reverie made flesh, and in all this darkness she alone, tall and slender, shines.",
        "aliases": [
          "wanda"
        ],
        "searchTags": [
          "Counter",
          "STR Down"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0053",
        "kind": "awakener",
        "name": "Winkle",
        "lineupToken": "t",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/winkle.webp",
          "full": "./generated-assets/awk-cards/winkle.webp"
        },
        "description": "Winkle's office is known as the North Star of Mythag University. It remains perpetually illuminated, with every corner where a shadow might lurk driven away by an array of lights—from lanterns and kerosene lamps to tungsten bulbs and candles.\n\nHer fear of darkness even causes her to avoid sleep. Thus, day and night, she can always be found huddled beneath the largest lamp, scrawling indecipherable symbols upon the draft papers scattered all over the floor.",
        "aliases": [
          "winkle"
        ],
        "searchTags": [
          "Counter",
          "Dispel",
          "Discard",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "Among the Stars"
      },
      {
        "id": "awakener-0054",
        "kind": "awakener",
        "name": "Xu",
        "lineupToken": "xh",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/xu.webp",
          "full": "./generated-assets/awk-cards/xu.webp"
        },
        "description": "Elegant, alluring—an Eastern \"deity\" of fatal charm.\n\nLegend has it that when she lowers her fan, you will see the face of your most beloved reflected beneath.\n\nYet legends are merely legends. Pray that her gaze never falls upon you. Once she seeps into your memories like a pervasive night mist, nothing will remain of your mind but a delirious, hollow obsession.",
        "aliases": [
          "xu"
        ],
        "searchTags": [
          "Poison",
          "STR Down",
          "Arithmetica",
          "Max HP DMG"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0055",
        "kind": "awakener",
        "name": "Vortice",
        "lineupToken": "xj",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/vortice.webp",
          "full": "./generated-assets/awk-cards/vortice.webp"
        },
        "description": "Language barriers? Not a problem—gestures work just fine. Uncontrollable power? At this school, that's par for the course. A few days in the lab usually resolve the issue.\n\nWith her beaming smile and a personality so blunt it borders on feral, Vortice quickly wins over the other Awakeners. Sure, she often wreaks havoc because she forgets what she's capable of (spare a thought for that fountain, rebuilt three times by now). But come on—she doesn't mean it!\n\n...Probably.",
        "aliases": [
          "vortice"
        ],
        "searchTags": [
          "Tentacle DMG",
          "Pursuit",
          "Fixed DMG",
          "Aftershock",
          "Dispel",
          "Divine Realm"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "ASSAULT",
        "faction": "The Fools"
      },
      {
        "id": "awakener-0056",
        "kind": "awakener",
        "name": "Arachne",
        "lineupToken": "3",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/arachne.webp",
          "full": "./generated-assets/awk-cards/arachne.webp"
        },
        "description": "The weaver ensnared by her own web; the playwright and eternal spectator of the Theater of Fate. \n\nThreads cascade from Arachne's fingertips, twining into curtains, scripts, and cages—each strand spun by her own hand, only to shroud her in an inescapable cocoon. \n\nThe auditorium remains forever vacant, with none but herself to gaze upon the solitary performance onstage—a drama repeating without end, a play that knows no final curtain. She is the phantom haunting the theater, and the very incarnation of Fate itself.",
        "aliases": [
          "arachne"
        ],
        "searchTags": [
          "Final Verdict",
          "Pursuit",
          "Dispel",
          "Divine Realm",
          "Self-Damage",
          "Spider"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "The Unknowable"
      },
      {
        "id": "awakener-0057",
        "kind": "awakener",
        "name": "Saya",
        "lineupToken": "xi",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/saya.webp",
          "full": "./generated-assets/awk-cards/saya.webp"
        },
        "description": "When all things are eroded by twisted flesh, when the everyday life is overturned, a dandelion drifts down upon this wasteland amid the keening noise. \n\nReach out your hand. Take hold of her. Love will break through the surface, and anchor you to the one you love once more.",
        "aliases": [
          "saya"
        ],
        "searchTags": [
          "Discard",
          "Corrosion",
          "Divine Realm",
          "Self-Damage"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "CHORUS",
        "faction": "TBD"
      },
      {
        "id": "awakener-0058",
        "kind": "awakener",
        "name": "Pontos",
        "lineupToken": "xo",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/pontos.webp",
          "full": "./generated-assets/awk-cards/pontos.webp"
        },
        "description": "The heroic epic destined to soar across the night sky was broken mid-flight. He chose to plunge into the abyss, offering himself up to an existence far greater and more inscrutable.\nNever again would he face the pangs of parting, the sting of mediocrity, or the inescapable ravages of time.\nHis kin, his friends, and even his foes—he has kept them all forever within Ebwynnos, a realm now fused with his very being.",
        "aliases": [
          "pontos"
        ],
        "searchTags": [
          "STR Down",
          "Tentacle DMG",
          "Fixed DMG",
          "Dispel",
          "Divine Realm"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "TBD"
      },
      {
        "id": "awakener-0059",
        "kind": "awakener",
        "name": "Lotan: Cetarchon",
        "lineupToken": "xq",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/lotan-cetarchon.webp",
          "full": "./generated-assets/awk-cards/lotan-cetarchon.webp"
        },
        "description": "No matter which dimension she's from, Lotan has little use for words—Lotan: Cetarchon even less so. Words mean nothing to her. Strength itself is the ultimate eloquence.\nBeneath a regal, unhurried composure lies her truest hunger, burning in heterochromatic eyes like dying stars—she is an ancient force risen from the abyss of the universe, a bone blade forged in the wrath of chaos. To her, all things fall into two categories: those worthy of a fight, and those not.\nCarved from the bones of the Astral Cetus, her twin blades hunger endlessly—just like her own unquenchable thirst for the zenith of strength.",
        "aliases": [
          "lotan cetarchon",
          "cetarchon",
          "glotan",
          "rotan"
        ],
        "searchTags": [
          "STR Up",
          "Divine Realm"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "Genesis",
        "type": "ASSAULT",
        "faction": "TBD"
      },
      {
        "id": "awakener-0060",
        "kind": "awakener",
        "name": "Caraboo",
        "lineupToken": "4",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/caraboo.webp",
          "full": "./generated-assets/awk-cards/caraboo.webp"
        },
        "description": "Like the most precocious of children, she is always attuned to your innermost thoughts, forever drawing out your trust and confessions, then, at just the right moment, offering you the \"blessing\" you've longed for. \nBut bear this in mind: never let her dainty frame and pitiful eyes stir compassion within you, lest you become one more of the many greedy souls that pure white form has devoured.",
        "aliases": [
          "caraboo"
        ],
        "searchTags": [
          "Weakness",
          "STR Up",
          "STR Down",
          "Fixed DMG",
          "Dispel",
          "Corrosion",
          "Divine Realm"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "type": "WARDEN",
        "faction": "TBD"
      },
      {
        "id": "awakener-0061",
        "kind": "awakener",
        "name": "Ogier: Oathbound",
        "lineupToken": "xs",
        "assets": {
          "thumb": "./generated-assets/awk-portraits/ogier-oathbound.webp",
          "full": "./generated-assets/awk-cards/ogier-oathbound.webp"
        },
        "description": "Though their frames are the same, the difference between this boy and the familiar little knight is plain to see.\nThe light has left his eyes; his white garments are sullied. More telling still, he keeps to himself, pointedly maintaining a distance from all living souls.\nBut there is no need to fear. Beneath that horrific slime beats the heart you once knew—one that still pulses for loyalty and justice.\nThough his oaths were once forsaken, he has at last reclaimed his creed.\nHe will continue his struggle—against the other voice echoing within him, and against any force that threatens what he holds dear.",
        "aliases": [
          "ogier oathbound",
          "genesis ogier",
          "gogier",
          "g-ogier"
        ],
        "searchTags": [
          "STR Up",
          "STR Down",
          "Corrosion",
          "Divine Realm"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "Genesis",
        "type": "WARDEN",
        "faction": "The Fools"
      }
    ],
    "wheels": [
      {
        "id": "wheel-0001",
        "kind": "wheel",
        "name": "Merciful Nurturing",
        "lineupToken": "xb",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B01.webp"
        },
        "description": "Team Unique: Hand Limit +2. At turn end, gain Keyflare equal to the wielder's 300% Keyflare Regen. After each Posse is Unleashed, all Awakeners gain 6 Aliemus. If the current Realm is Caro, also trigger Embryo Fusion +25.",
        "aliases": [],
        "searchTags": [
          "Hand Limit",
          "Keyflare",
          "Aliemus",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Thais"
      },
      {
        "id": "wheel-0002",
        "kind": "wheel",
        "name": "Tablet of Scriptures",
        "lineupToken": "xC",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B02.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +15%, and HP Recovery +15%. At the end of odd turns, the wielder's Crit. Rate +6%, gaining 8 Aliemus; at the end of even turns, the wielder's Crit. DMG +6%, gaining 120 Keyflare. If the current realm is Caro, the Crimson Furnace maximum accumulation +40%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal",
          "Keyflare",
          "Aliemus",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Salvador"
      },
      {
        "id": "wheel-0003",
        "kind": "wheel",
        "name": "Winter's Requiem",
        "lineupToken": "W",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B03.webp"
        },
        "description": "Team Unique: At battle start, inflict 2 stacks of Vulnerable on front-row enemies. At the start of each turn, enemies in the Vulnerable state lose Temporary STR equal to 12% of the wielder's ATK. If the current Realm is Caro, after the wielder Unleashes \"Exalt\", Embryo Fusion +15.",
        "aliases": [],
        "searchTags": [
          "Vulnerable",
          "STR Down",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Aigis"
      },
      {
        "id": "wheel-0004",
        "kind": "wheel",
        "name": "By Rose Alone",
        "lineupToken": "xc",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B04.webp"
        },
        "description": "Team Unique: For every instance of DMG dealt by the wielder, there is a 100% chance for the wielder to gain 2% Temporary Crit. DMG. After the wielder releases Exalt, they deal Active DMG 3 times to a random enemy equal to 30% of the wielder's ATK. If the current realm is Caro, for every Embryo Devoured, Embryo Fusion +25.",
        "aliases": [],
        "searchTags": [
          "Crit DMG",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Sorel"
      },
      {
        "id": "wheel-0005",
        "kind": "wheel",
        "name": "Chains Unbound",
        "lineupToken": "3",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B05.webp"
        },
        "description": "Team Unique: The Base DMG of the wielder's cards +40%. At the start of each turn, there is a 30% chance to create a Basic Copy of a random one of the wielder's non-Derived Command Cards; the copy has Exhaust. Whenever an Embryo is played targeting the wielder, the Crit. Rate of their next \"Strike\" +35%.",
        "aliases": [],
        "searchTags": [
          "Strike",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Helot"
      },
      {
        "id": "wheel-0006",
        "kind": "wheel",
        "name": "Drowning in Crimson",
        "lineupToken": "xY",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B05EX.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B05EX.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +40%. Before the wielder releases Exalt, temporary hand size +1, and draw 1 of the wielder's Command Cards. If the current realm is Caro, when the wielder triggers Devour, Temporary Crit. DMG +40%, up to 1 time per turn.",
        "aliases": [],
        "searchTags": [
          "Draw",
          "Hand Limit",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Helot: Catena"
      },
      {
        "id": "wheel-0007",
        "kind": "wheel",
        "name": "Pale Descendant",
        "lineupToken": "xA",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B06.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +10%. The wielder's \"Defense\" s inflict Poison equal to 24% of their DEF on the enemy with the highest HP. If the current Realm is Caro, whenever Poison is inflicted on an enemy, increase Embryo Fusion by +12, up to 3 times per turn.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Shield",
          "Defense",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Agrippa"
      },
      {
        "id": "wheel-0008",
        "kind": "wheel",
        "name": "Bloody Feast",
        "lineupToken": "0",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B07.webp"
        },
        "description": "Team Unique: The Crit. Rate & Crit. DMG of the wielder's Exalt each +15%. After the wielder Exalts, gain STR equal to 6% of their CON. If Devour was triggered, gain STR one more time.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Uvhash"
      },
      {
        "id": "wheel-0009",
        "kind": "wheel",
        "name": "The Glutton's Tale",
        "lineupToken": "xk",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B08.webp"
        },
        "description": "Team Unique: The wielder's HP Recovery +15%. At the start of each turn, gain Temporary STR and Shield equal to 15% of the total amount of HP lost last turn.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield",
          "Heal"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Leigh"
      },
      {
        "id": "wheel-0010",
        "kind": "wheel",
        "name": "Lullaby Devoured",
        "lineupToken": "C",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B09.webp"
        },
        "description": "Team Unique: At battle start, gain Counter equal to 50% of the wielder's DEF. After triggering Death Resistance, gain up to 2 stacks of \"Cradle\" in total: Shield gained from and HP recovered by all allies +30%, remove 1 stack at turn end. If the current Realm is Caro, after triggering Death Resistance, Embryo Fusion +25.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "Death Resistance",
          "Shield",
          "Heal",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Faint"
      },
      {
        "id": "wheel-0011",
        "kind": "wheel",
        "name": "Kiss of Repose",
        "lineupToken": "yL",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B10.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +25%. During this exploration, every time the wielder kills an enemy, their Crit. Rate +2% and Exalt Base DMG +5%, up to 10 times. If the current Realm is Caro, the wielder gains an extra 30 Aliemus when they directly consume Embryo. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Doresain"
      },
      {
        "id": "wheel-0012",
        "kind": "wheel",
        "name": "Paradoxical Realism",
        "lineupToken": "yd",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B12.webp"
        },
        "description": "Team Unique: The wielder's Aliemus Generation and STR Generation +12%. After unleashing Exalt, the Final DMG, Shield, and HP Recovery from the next Exalt released by other Awakeners this turn +15%. If this Exalt triggered Devour, the wielder gains 15 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Pickman"
      },
      {
        "id": "wheel-0013",
        "kind": "wheel",
        "name": "Vain Regrets",
        "lineupToken": "yR",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B14.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B14.webp"
        },
        "description": "Team Unique: The wielder's Fixed Poison Infliction and Poison Trigger +30%, and Caro Realm's automatic Embryo Fusion +30%. When the wielder first triggers Resonance each turn, other Awakeners gain 10 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Aliemus",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Xu"
      },
      {
        "id": "wheel-0014",
        "kind": "wheel",
        "name": "Rewinding Time",
        "lineupToken": "Z",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C01.webp"
        },
        "description": "Team Unique: Whenever one of the wielder's cards is played, there is a 60% chance to return it to hand from the Discard Pile. This effect triggers only once each turn.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Ramona"
      },
      {
        "id": "wheel-0015",
        "kind": "wheel",
        "name": "Deathless Ascent",
        "lineupToken": "4",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C02.webp"
        },
        "description": "Team Unique: The wielder's Command Card HP Recovery +25%. After the wielder Exalts, grant all other Awakeners 8 Aliemus. If Awakeners were Vulnerable before the Exalt was released, Aliemus granted this way is doubled.",
        "aliases": [],
        "searchTags": [
          "Heal",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Doll"
      },
      {
        "id": "wheel-0016",
        "kind": "wheel",
        "name": "Manikin of Oblivion",
        "lineupToken": "xW",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C02EX.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C02EX.webp"
        },
        "description": "Team Unique: The wielder's Poison Infliction, Aliemus Generation, and HP Recovery each +10%. After the wielder Exalts, they gain Aliemus equal to 20% of the Aliemus consumed by that Exalt. <Italic:(Aliemus generation bonuses, such as this Wheel, can affect this amount.)>",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Heal",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Doll: Inferno"
      },
      {
        "id": "wheel-0017",
        "kind": "wheel",
        "name": "Heart of a Knight",
        "lineupToken": "8",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C03.webp"
        },
        "description": "Team Unique: The wielder's Exalt Shield Generation +25%. After the wielder Exalts, gain Temporary STR equal to 25% of the wielder's DEF. If Awakeners were Fragile before the Exalt was released, STR gained this way is doubled.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Ogier"
      },
      {
        "id": "wheel-0018",
        "kind": "wheel",
        "name": "Celestial Beast",
        "lineupToken": "c",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C04.webp"
        },
        "description": "Team Unique: The Base DMG of the wielder's Exalt and \"Strike\" s each +50%. Whenever one of their \"Strike\" s is played, the wielder's Crit. Rate +5% this turn. This effect stacks up to 3 times, and when stacks reach 3, the wielder's Crit. DMG +15% this turn.",
        "aliases": [],
        "searchTags": [
          "Strike",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Lotan"
      },
      {
        "id": "wheel-0019",
        "kind": "wheel",
        "name": "Hour of Fortune",
        "lineupToken": "xJ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C05.webp"
        },
        "description": "Team Unique: At battle start, the Crit. Rate of the wielder's Command Cards +3% for each Relic acquired. After the wielder Exalts, roll a 4-sided die; they gain +X% Temp. Crit. DMG & X Aliemus, where X is 6 times the result. If the result is 4 or higher, also grant other Awakeners half of this effect.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Ryker"
      },
      {
        "id": "wheel-0020",
        "kind": "wheel",
        "name": "Aberrant Devour",
        "lineupToken": "n",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C06.webp"
        },
        "description": "Team Unique: The Base DMG of the wielder's Exalt +60%. At the start of investigation, the wielder gains \"Scholar Persona\". After the wielder Exalts, they switch between Scholar and Jester Personas. Scholar: The wielder gains 20 Aliemus at the end of each turn. Jester: The wielder's Crit. Rate & Crit. DMG +7% at the end of each turn.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "24"
      },
      {
        "id": "wheel-0021",
        "kind": "wheel",
        "name": "Memory Spiral",
        "lineupToken": "7",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C07.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +20%. At turn start, Retain 50% of unbroken Shield, up to 20% of Max HP.",
        "aliases": [],
        "searchTags": [
          "Shield"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Nautila"
      },
      {
        "id": "wheel-0022",
        "kind": "wheel",
        "name": "Gift of Decay",
        "lineupToken": "o",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C08.webp"
        },
        "description": "Team Unique: The wielder's Poison Infliction +25%. As part of the wielder's Exalt, first inflict Poison equal to 30% of the wielder's ATK on all enemies; then resolve the Exalt's effects. Whenever Posse is unleashed, the wielder gains 8 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Nymphaea"
      },
      {
        "id": "wheel-0023",
        "kind": "wheel",
        "name": "Drifting in Desire",
        "lineupToken": "xd",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C09.webp"
        },
        "description": "Team Unique: The wielder's Counter Generation +25%. Whenever an enemy attacks, gain Temporary STR equal to 8% of the wielder's ATK for each hit. After the wielder Exalts, gain Counter equal to 15% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "STR Up"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Pandia"
      },
      {
        "id": "wheel-0024",
        "kind": "wheel",
        "name": "Grace Through Pain",
        "lineupToken": "R",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C10.webp"
        },
        "description": "Team Unique: The wielder's Poison Infliction and Shield Generation +15%, and the Crit. Rate & Crit. DMG of the wielder's \"Strike\" s +35%. The first time one of their \"Strike\" s is played each turn, gain Shield equal to 7% of Max HP.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Shield",
          "Strike",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Lily"
      },
      {
        "id": "wheel-0025",
        "kind": "wheel",
        "name": "Will Unyielding",
        "lineupToken": "G",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C11.webp"
        },
        "description": "Team Unique: The wielder's Base DMG and Shield Generation +15%. At the start of investigation, add 1 of the wielder's Basic Strike and 1 of their Basic Defense to the deck. Whenever one of their \"Strike\" s is played, Shield gained from their next \"Defense\" +15%; whenever one of their \"Defense\" s is played, the Crit. Rate & Crit. DMG of their next \"Strike\" +15%. These effects can stack up to 3 times and persist between battles.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Strike",
          "Defense",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Alva"
      },
      {
        "id": "wheel-0026",
        "kind": "wheel",
        "name": "Silent Banquet",
        "lineupToken": "xh",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C12.webp"
        },
        "description": "Team Unique: The wielder's Poison Infliction +15%. After the wielder Exalts, recover HP equal to 20% of their CON, plus another 5% of their CON for each unspent Arithmetica.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Heal"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Karen"
      },
      {
        "id": "wheel-0027",
        "kind": "wheel",
        "name": "Wheel Unseen",
        "lineupToken": "xV",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C15.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C15.webp"
        },
        "description": "Team Unique: Hand Limit +2. <Italic:(Does not stack with other Wheels.)> Keyflare Limit +100%. The wielder's Keyflare Regen +25%. After one of the wielder's cards is played, the Crit. Rate & Crit. DMG of, Aliemus generated by, and Shield & STR gained from the wielder's Command Cards each +6% this turn. (This effect stacks up to 5 times.)",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Hand Limit",
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Tawil"
      },
      {
        "id": "wheel-0028",
        "kind": "wheel",
        "name": "Amber-Tinted Death",
        "lineupToken": "yn",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C16.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C16.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +35%, and STR Generation +12%. Whenever one of the wielder's Command Cards is played, gain Temporary STR equal to 20% of their ATK. (This effect stacks up to 5 times.)",
        "aliases": [],
        "searchTags": [
          "STR Up"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Kathigu-Ra"
      },
      {
        "id": "wheel-0029",
        "kind": "wheel",
        "name": "Doomsday Rampage",
        "lineupToken": "yJ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C17.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C17.webp"
        },
        "description": "Team Unique: The Base DMG of the wielder's Exalt and Pursuit each +60%. After any Awakener's \"Strike\" is played, DMG dealt by the wielder's \"Strike\" s this turn increases by 25% of the wielder's ATK. (This effect stacks up to 8 times.)",
        "aliases": [],
        "searchTags": [
          "Pursuit",
          "Strike"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Mouchette"
      },
      {
        "id": "wheel-0030",
        "kind": "wheel",
        "name": "Fouetté",
        "lineupToken": "t",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D01.webp"
        },
        "description": "Team Unique: The wielder's Active DMG +an amount equal to the wielder's ATK ×20%. After playing or discarding 1 of the wielder's Command Cards, deal Poison equal to the wielder's ATK ×12% to a random enemy once. After the Ultra Round ends, there is a 100% chance to trigger 100% Poison on all enemies.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Discard"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Liz"
      },
      {
        "id": "wheel-0031",
        "kind": "wheel",
        "name": "Treasured Rarity",
        "lineupToken": "l",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D02.webp"
        },
        "description": "Team Unique: Gain 2 Black Sigils each time an enemy dies. After the wielder kills an enemy, the wielder's Crit. DMG in this stage permanently +10%, stacking up to 5 stacks. Each time the wielder triggers the Leap effect, increase the Final DMG dealt by the wielder this turn by 5%, stacking up to 3 stacks.",
        "aliases": [],
        "searchTags": [
          "Crit DMG",
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Daffodil"
      },
      {
        "id": "wheel-0032",
        "kind": "wheel",
        "name": "Song of the Bound",
        "lineupToken": "X",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D03.webp"
        },
        "description": "Team Unique: At the start of exploration, add one derived:Insight and the wielder's \"Strike\" to the deck. the wielder's \"Strike\" Base DMG +30%, and after playing, there is a 100% chance to draw 1 card. This effect can trigger a maximum of once per turn. If the current Realm is Ultra and during the Ultra Round, the \"Strike\" will place 1 derived:Insight into hand, triggering a maximum of once during that turn.",
        "aliases": [],
        "searchTags": [
          "Draw",
          "Strike"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Tinct"
      },
      {
        "id": "wheel-0033",
        "kind": "wheel",
        "name": "Queen's Edict",
        "lineupToken": "D",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D04.webp"
        },
        "description": "Team Unique: The wielder's Counter Generation +25%. After the wielder plays a card, gain Counter equal to 8% of the wielder's DEF, up to 2 times per turn. If the card played enters Ultra Space, the wielder also gains 12 Aliemus. After releasing Exalt, all enemies lose Temporary STR equal to 15% of the wielder's DEF.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "STR Down",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Wanda"
      },
      {
        "id": "wheel-0034",
        "kind": "wheel",
        "name": "Incalculable Factor",
        "lineupToken": "xf",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D05.webp"
        },
        "description": "Team Unique: The Aliemus generated by the wielder +15%. The wielder gains 200 Keyflare after releasing Exalt.",
        "aliases": [],
        "searchTags": [
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Winkle"
      },
      {
        "id": "wheel-0035",
        "kind": "wheel",
        "name": "The Last Verse",
        "lineupToken": "k",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D06.webp"
        },
        "description": "Team Unique: The wielder's Command Card Crit. Rate and Crit. DMG, Shield Generation, HP Recovery, Aliemus, and STR +20%. If the current realm is Ultra, gain 200 Keyflare after releasing Annihilation. After entering the Ultra Round, the next Posse is released twice this turn.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal",
          "Keyflare",
          "Aliemus",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Horla"
      },
      {
        "id": "wheel-0036",
        "kind": "wheel",
        "name": "Path Forsaken",
        "lineupToken": "2",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D07.webp"
        },
        "description": "Team Unique: After the wielder deals Active DMG, there is a 30% chance to draw 1 of their Command Cards and reduce its Arithmetica Cost by 1. This effect activates only once per turn.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Draw"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Jenkin"
      },
      {
        "id": "wheel-0037",
        "kind": "wheel",
        "name": "Core Meltdown",
        "lineupToken": "s",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D08.webp"
        },
        "description": "Team Unique: The Base DMG of the wielder's \"Strike\" +25%, and the Base Shield of \"Defense\" +25%. When playing the wielder's \"Strike, \" gain Temporary STR equal to the wielder's ATK 15%, and when playing the wielder's \"Defense, \" gain Temporary Alert equal to the wielder's DEF 5%. If the current realm is Ultra, receive a Temporary STR and Temporary Alert when entering the Ultra Round",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield",
          "Strike",
          "Defense"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Erica"
      },
      {
        "id": "wheel-0038",
        "kind": "wheel",
        "name": "Happy Magic Show",
        "lineupToken": "S",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D09.webp"
        },
        "description": "Team Unique: After the wielder releases Exalt, they gain 6 Aliemus and 50 Keyflare, repeating once for every 4 cards in hand. If the current Realm is Ultra, after the wielder's cards enter Ultra Space, gain Temporary STR equal to 12% of the wielder's ATK, triggering up to 2 times per turn.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Casiah"
      },
      {
        "id": "wheel-0039",
        "kind": "wheel",
        "name": "Unbearable Freedom",
        "lineupToken": "yb",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D11.webp"
        },
        "description": "Team Unique: Hand Limit +2. <Italic:(Does not stack with other Wheels.)> The wielder's Base DMG and Shield Generation +15%. Obtain 80 Aliemus upon entering the Ultra Round. Release Annihilation to grant all Awakeners Temporary Crit. DMG +25%. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Hand Limit",
          "Aliemus",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Castor"
      },
      {
        "id": "wheel-0040",
        "kind": "wheel",
        "name": "Eternal Requiem",
        "lineupToken": "xX",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D12.webp"
        },
        "description": "Team Unique: At exploration start, add 1 derived:Silver Key Dawn with Destroy to the deck. Whenever Posse is unleashed, the wielder's Crit. DMG +5%. Whenever the wielder deals Active DMG, their Crit. Rate +8% this turn, and team gains Keyflare equal to 80% of their Keyflare Regen, up to 5 times each turn.",
        "aliases": [],
        "searchTags": [
          "Keyflare",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Hameln"
      },
      {
        "id": "wheel-0041",
        "kind": "wheel",
        "name": "Veiled Anguish",
        "lineupToken": "yf",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D13.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D13.webp"
        },
        "description": "Team Unique: The wielder's Exalt Base DMG +50%, and Keyflare Regen +30%. After entering Ultra Round, all Awakeners obtain 20 Aliemus. After releasing Annihilation, the wielder obtains 20 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Clementine"
      },
      {
        "id": "wheel-0042",
        "kind": "wheel",
        "name": "Twisted Knight Ballad",
        "lineupToken": "yg",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D14.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D14.webp"
        },
        "description": "Team Unique: The wielder's cards gain +35% Base DMG and Crit. DMG. At the start of your turn and after using the wielder's Exalt, gain 1 stack of Alight. When the wielder's Command Card is played, consume 1 stack to increase its Final DMG and Shield by 15%. During an Ultra Round, gain Ablaze instead (effect doubled).",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Pollux"
      },
      {
        "id": "wheel-0043",
        "kind": "wheel",
        "name": "Special Training",
        "lineupToken": "yH",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP01.webp"
        },
        "description": "Team Unique: After unleashing a Posse, the wielder's Crit. Rate is temporarily+35%.",
        "aliases": [],
        "searchTags": [
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0044",
        "kind": "wheel",
        "name": "School Day",
        "lineupToken": "yG",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP02.webp"
        },
        "description": "Team Unique: After resetting stock at \"D-Mark\" and Ashen Ruins, the wielder gains 50 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0045",
        "kind": "wheel",
        "name": "Dear Papa Noel",
        "lineupToken": "yO",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP03.webp"
        },
        "description": "Team Unique: Your first purchase of an \"Orison\" in the \"D-Mark\" store or your first purchase of a discounted item in the Ashen Ruins has a 100% chance to cost 0 Black Sigils. This can trigger only once per Exploration.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0046",
        "kind": "wheel",
        "name": "Countdown Moment",
        "lineupToken": "yP",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP04.webp"
        },
        "description": "Team Unique: At the start of exploration, add 1 card 5: Countdown to the deck. 5: Countdown: Draw 1 card after played, shuffle the next Countdown into the Discard Pile, Destroy. 0: Countdown: Draw 3 cards, gain 3 Arithmetica, and have a 100% chance to shuffle 5: Countdown into the Discard Pile, Retain, Destroy.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Draw"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0047",
        "kind": "wheel",
        "name": "Stakes of Wisdom",
        "lineupToken": "yX",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP06.webp"
        },
        "description": "Team Unique: After exploration starts, shuffle 1 derived:Stakes of Wisdom into the Draw Pile. derived:Stakes of Wisdom: Cost 1 Arithmetica. Shuffle all Command Cards in hand randomly into the Draw Pile. Shuffled Command Cards have a 25% chance to take effect 1 additional time when played next, and for each Command Card shuffled in, all Awakeners gain 2 Aliemus. Retain. Exhaust. Innate.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0048",
        "kind": "wheel",
        "name": "Unsent Flowers",
        "lineupToken": "ya",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_N01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_N01.webp"
        },
        "description": "Team Unique: If the wielder is the Awakener \"Ramona,\" the Affinity gained upon completing the stage +50%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "N",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0049",
        "kind": "wheel",
        "name": "Roses in Mud",
        "lineupToken": "yS",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_N02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_N02.webp"
        },
        "description": "Team Unique: If the wielder is the Awakener \"Ramona: Timeworn,\" the Affinity gained by other Awakeners upon completing the stage +50%, but the wielder does not gain any Affinity.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "N",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0050",
        "kind": "wheel",
        "name": "Hymn of the Sovereign",
        "lineupToken": "B",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O01.webp"
        },
        "description": "Team Unique: At the start of each battle, the wielder gains 40 Aliemus. Whenever another Awakener Exalts, the wielder gains 6 Aliemus. After the wielder Exalts, gain Tentacle DMG equal to 5% of their ATK.",
        "aliases": [],
        "searchTags": [
          "Tentacle DMG",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Tulu"
      },
      {
        "id": "wheel-0051",
        "kind": "wheel",
        "name": "Shrouded Birth",
        "lineupToken": "m",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O02.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +15%. Whenever the wielder generates Shield, all Awakeners gain +8% Temporary Crit. Rate, and the team gains Keyflare equal to 150% of the wielder's Keyflare Regen, up to 2 times per turn. If the current Realm is Aequor, whenever a Tentacle attacks, the wielder gains 1 Aliemus (up to 10 per turn).",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Keyflare",
          "Aliemus",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Murphy"
      },
      {
        "id": "wheel-0052",
        "kind": "wheel",
        "name": "Amidst the Downpour",
        "lineupToken": "v",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O03.webp"
        },
        "description": "Team Unique: The wielder's \"Strike\" s have a 100% chance to generate 1 Arithmetica and trigger 10% of each enemy's Poison. This effect triggers only once each turn. If the Realm includes Aequor, this effect also triggers 1 Tentacle attack.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Arithmetica",
          "Strike"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Faros"
      },
      {
        "id": "wheel-0053",
        "kind": "wheel",
        "name": "Fin of Sorrow",
        "lineupToken": "e",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O04.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation and HP Recovery each increase by 4% of the wielder's CON, and Counter Generation +15%. Whenever one of the wielder's \"Defense\" s is played, gain Counter equal to 20% of the wielder's DEF. At battle start, gain STR and Tentacle DMG equal to 12% of the wielder's CON.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "STR Up",
          "Tentacle DMG",
          "Shield",
          "Heal",
          "Defense"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Caecus"
      },
      {
        "id": "wheel-0054",
        "kind": "wheel",
        "name": "Dream of the Sea",
        "lineupToken": "9",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O05.webp"
        },
        "description": "Team Unique: Whenever one of the wielder's cards is played, they gain 1 Aliemus. At battle start, gain STR equal to 9% of the wielder's ATK and Tentacle DMG equal to 6% of their ATK. At the start of each following turn, gain STR equal to 3% of the wielder's ATK and Tentacle DMG equal to 2% of their ATK.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Tentacle DMG",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Aurita"
      },
      {
        "id": "wheel-0055",
        "kind": "wheel",
        "name": "Blade of the Titan",
        "lineupToken": "1",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O06.webp"
        },
        "description": "Team Unique: After the wielder Exalts, their Crit. DMG +60% this turn, and each of their cards in hand has a 35% chance to have their Arithmetica Cost reduced by 1 until the end of the turn.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Goliath"
      },
      {
        "id": "wheel-0056",
        "kind": "wheel",
        "name": "Power of the Pious",
        "lineupToken": "xK",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O07.webp"
        },
        "description": "Team Unique: The wielder's Aliemus Generation +10%, and Poison Infliction +15%. After the wielder deals Active DMG, all Awakeners gain Temporary Crit. DMG equal to 20% of the wielder's Base Crit. DMG. If the Realm includes Aequor, Tentacle Limit +1, and spawn 1 Tentacle at battle start.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Aliemus",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Miryam"
      },
      {
        "id": "wheel-0057",
        "kind": "wheel",
        "name": "Death of Ms. Coral",
        "lineupToken": "A",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O08.webp"
        },
        "description": "Team Unique: Whenever one of the wielder's cards is played, gain Shield equal to 12% of the wielder's DEF, plus another 3% of their DEF for each Tentacle. This effect triggers only once each turn.",
        "aliases": [],
        "searchTags": [
          "Shield"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Sanga"
      },
      {
        "id": "wheel-0058",
        "kind": "wheel",
        "name": "Sail of Providence",
        "lineupToken": "f",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O09.webp"
        },
        "description": "Team Unique: The wielder's HP Recovery +10%. When the wielder Exalts, recover 10% of missing HP at the start of next turn.",
        "aliases": [],
        "searchTags": [
          "Heal"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Celeste"
      },
      {
        "id": "wheel-0059",
        "kind": "wheel",
        "name": "Flamebound Navigator",
        "lineupToken": "ye",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O10.webp"
        },
        "description": "Team Unique: Shield gained from the wielder's Exalt +30%. After the wielder Exalts, all Awakeners gain +20% Temp. Crit. DMG, and another +1% for each Tentacle. The first time Death Resistance triggers each investigation, recover 25% of Max HP at the start of your next turn.",
        "aliases": [],
        "searchTags": [
          "Death Resistance",
          "Shield",
          "Heal",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Corposant"
      },
      {
        "id": "wheel-0060",
        "kind": "wheel",
        "name": "The Faraway Eden",
        "lineupToken": "yV",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O11.webp"
        },
        "description": "Team Unique: At the start of each battle, the wielder gains Aliemus equal to 25% of their Base Aliemus. The Final DMG dealt by the wielder's Exalt increases by a percentage equal to 20% of their Base Aliemus. Upon switching to the Raging Waves stance, gain Temp. Realm Mastery equal to 35% of current Realm Mastery. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Temporary Realm Mastery"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Vortice"
      },
      {
        "id": "wheel-0061",
        "kind": "wheel",
        "name": "Gluttony",
        "lineupToken": "xs",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P01.webp"
        },
        "description": "Team Unique: After a normal battle, you can choose to forgo an Orison and increase Max HP by 20%. Takes effect up to 2 times. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0062",
        "kind": "wheel",
        "name": "Frenzy",
        "lineupToken": "xr",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P02.webp"
        },
        "description": "Team Unique: The number of Relic Slots becomes 3, with one being a Cursed Relic Slot. Purchasing a Cursed Relic grants 15 Black Sigils. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0063",
        "kind": "wheel",
        "name": "Favor",
        "lineupToken": "xq",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P03.webp"
        },
        "description": "Team Unique: After each stage starts, all Awakeners gain 20 Aliemus. At the start of a Boss Battle, draw 2 cards. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Draw",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0064",
        "kind": "wheel",
        "name": "Emerge",
        "lineupToken": "xp",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P04.webp"
        },
        "description": "Team Unique: D-Mark Store refresh attempts +1, refresh cost reduced by 5 Black Sigils. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0065",
        "kind": "wheel",
        "name": "Delirium",
        "lineupToken": "xo",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P05.webp"
        },
        "description": "Team Unique: Reduce the cost of Rouse cards in D-Mark Store by 15 Black Sigils. the wielder's Rouse card gains Innate. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0066",
        "kind": "wheel",
        "name": "Whisper",
        "lineupToken": "xn",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P06.webp"
        },
        "description": "Team Unique: After each battle ends, the Awakener with the lowest Aliemus gains 50 Aliemus. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0067",
        "kind": "wheel",
        "name": "Hope",
        "lineupToken": "xm",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P07.webp"
        },
        "description": "Team Unique: Recover 5% of lost HP after walking a new Tile. After using an Emergency Gnosis, increase all Awakeners' Crit. Rate and Crit. DMG by 100%. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Heal",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0068",
        "kind": "wheel",
        "name": "Epiphany",
        "lineupToken": "xu",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P08.webp"
        },
        "description": "Team Unique: After each stage starts, gain 1000 Keyflare. At the start of a Boss Battle, gain 2 Arithmetica. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0069",
        "kind": "wheel",
        "name": "Punishment",
        "lineupToken": "xt",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P09.webp"
        },
        "description": "Team Unique: After the Boss Battle starts, consume up to 50 Black Sigils, with each point of Black Sigil consumed granting 5% Death Resistance. In the Astral Reign, the effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Death Resistance"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0070",
        "kind": "wheel",
        "name": "Blessing",
        "lineupToken": "xl",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P10.webp"
        },
        "description": "Team Unique: After a normal battle ends, the number of available Orisons becomes 4. Orisons on the wielder's cards has a 30% chance to upgrade to Advanced. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0071",
        "kind": "wheel",
        "name": "Vitality",
        "lineupToken": "xi",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P11.webp"
        },
        "description": "Team Unique: Rest Areas provide an additional option: Destroy up to 3 Symptom cards, obtain 20 Black Sigils. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0072",
        "kind": "wheel",
        "name": "Exile",
        "lineupToken": "xj",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P12.webp"
        },
        "description": "Team Unique: Symptom Cards can be sold for 25 Black Sigils. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\".",
        "aliases": [],
        "searchTags": [
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0073",
        "kind": "wheel",
        "name": "Suction",
        "lineupToken": "g",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P13.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P13.webp"
        },
        "description": "Team Unique: Increases the HP Recovery at Rest Areas by 40%. After choosing to recover HP, add 2 derived:Insight cards to the deck. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Heal"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0074",
        "kind": "wheel",
        "name": "Aged",
        "lineupToken": "i",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P14.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P14.webp"
        },
        "description": "Team Unique: After each battle ends, gain 1000 Keyflare. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0076",
        "kind": "wheel",
        "name": "Insight",
        "lineupToken": "xv",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P16.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P16.webp"
        },
        "description": "Team Unique: Vision +1 during exploration, gain 30 Black Sigil after the map is fully revealed. At the start of Boss Battles, Weakness and Vulnerable all enemies for 1 turn. In the Astral Reign, the effect is changed to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0077",
        "kind": "wheel",
        "name": "Duty's Gravitas",
        "lineupToken": "5",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR01.webp"
        },
        "description": "Team Unique: After the wielder triggers Exalt, all allies gain 5 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0078",
        "kind": "wheel",
        "name": "Elevated Focus",
        "lineupToken": "xD",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR02.webp"
        },
        "description": "Team Unique: After triggering Posse, the wielder gains 15 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0079",
        "kind": "wheel",
        "name": "Cursed Binding",
        "lineupToken": "6",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR03.webp"
        },
        "description": "Team Unique: The wielder's Poison Infliction +12%. \"Strike\" inflicts Poison equal to 15% of the wielder's ATK on the target enemy. This effect can trigger a maximum of 3 times per turn.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Strike"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0080",
        "kind": "wheel",
        "name": "Sever and Scar",
        "lineupToken": "xE",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR04.webp"
        },
        "description": "Team Unique: The wielder's \"Strike\" causes the target enemy to lose Temporary STR equal to 12% the wielder's ATK. This effect can trigger a maximum of 3 times per turn.",
        "aliases": [],
        "searchTags": [
          "STR Down",
          "Strike"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0081",
        "kind": "wheel",
        "name": "Cloaked in the Night",
        "lineupToken": "V",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR05.webp"
        },
        "description": "Team Unique: The wielder's Counter Generation +12%. \"Defense\" grants Temporary Counter equal to 30% of the wielder's DEF. In Boss Battles, this becomes 3 times the Temporary Counter. After Death Resistance triggers, trigger 100% Counter against all enemies.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "Death Resistance",
          "Defense"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0082",
        "kind": "wheel",
        "name": "Adventurer's Pack",
        "lineupToken": "xF",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR06.webp"
        },
        "description": "Team Unique: After playing the wielder's \"Defense,\" gain Temporary STR equal to 18% the wielder's ATK.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Defense"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0083",
        "kind": "wheel",
        "name": "Analysis of Death",
        "lineupToken": "xG",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR07.webp"
        },
        "description": "Team Unique: After killing an enemy, the wielder gains 20 Aliemus and 1% Crit. DMG, effective for the entire exploration.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0084",
        "kind": "wheel",
        "name": "To My Dearest Friend",
        "lineupToken": "xH",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR08.webp"
        },
        "description": "Team Unique: After the wielder uses Exalt, all allies' Crit. Rate + 25% this turn.",
        "aliases": [],
        "searchTags": [
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0085",
        "kind": "wheel",
        "name": "Memory Syndrome",
        "lineupToken": "xI",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR09.webp"
        },
        "description": "Team Unique: After playing a Symptom card, the wielder gains 12 Aliemus. This effect triggers up to 2 times per turn. After playing a Command Card, the wielder gains 1 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0086",
        "kind": "wheel",
        "name": "Mind Barrier",
        "lineupToken": "J",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR10.webp"
        },
        "description": "Team Unique: After Exalt, gain Shield equal to 25% of the wielder's DEF.",
        "aliases": [],
        "searchTags": [
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0087",
        "kind": "wheel",
        "name": "Critical Point",
        "lineupToken": "U",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR11.webp"
        },
        "description": "Team Unique: After dealing Active DMG, the wielder's Crit. Rate + 10%. After a critical hit, the Crit. Rate gained from this effect is reset.",
        "aliases": [],
        "searchTags": [
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0088",
        "kind": "wheel",
        "name": "Nobleman's Staff",
        "lineupToken": "H",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR12.webp"
        },
        "description": "Team Unique: The wielder's Exalt Base DMG +30%, Shield Generation and HP Recovery +15%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0089",
        "kind": "wheel",
        "name": "Data is Flesh",
        "lineupToken": "I",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR13.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR13.webp"
        },
        "description": "Team Unique: The wielder's Command Card Base DMG +30%, Shield Generation and HP Recovery +15%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0090",
        "kind": "wheel",
        "name": "Moment of Reunion",
        "lineupToken": "r",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR14.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR14.webp"
        },
        "description": "Team Unique: Each time a card of the wielder is played, gain 50 Keyflare. This effect can trigger up to 3 times per turn.",
        "aliases": [],
        "searchTags": [
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0091",
        "kind": "wheel",
        "name": "The Land of Nonexistence",
        "lineupToken": "M",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR15.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR15.webp"
        },
        "description": "Team Unique: At the start of exploration, add one \"Defense\" of the wielder to the deck, increasing the Shield of the wielder's \"Defense\" by 40%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Defense"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0092",
        "kind": "wheel",
        "name": "Hand of Oblivion",
        "lineupToken": "K",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR16.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR16.webp"
        },
        "description": "Team Unique: At the start of exploration, add one \"Strike\" of the wielder to the deck, increasing the Base DMG of the wielder's \"Strike\" by 40%.",
        "aliases": [],
        "searchTags": [
          "Strike"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0093",
        "kind": "wheel",
        "name": "35mm Magic",
        "lineupToken": "xM",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR17.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR17.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation and Poison Infliction +10%. Upon triggering Death Resistance, all Awakeners gain 15% Temporary Crit. Rate and Crit. DMG.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Death Resistance",
          "Shield",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Lily"
      },
      {
        "id": "wheel-0094",
        "kind": "wheel",
        "name": "The Gaze of Isarawu",
        "lineupToken": "xN",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR18.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR18.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation and Counter Generation +10%. When attacked, there is a 100% chance for all Awakeners to gain 1 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Counter",
          "Shield",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Wanda"
      },
      {
        "id": "wheel-0095",
        "kind": "wheel",
        "name": "Man in the Mirror",
        "lineupToken": "xO",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR19.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR19.webp"
        },
        "description": "Team Unique: At turn end, the wielder gains 5 Aliemus. When taking Active and Tentacle DMG, gain Shield equal to 3% of the DMG at the start of next turn. If the current Realm is Caro, gain Crimson Furnace equal to 3% of the DMG instead.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Salvador"
      },
      {
        "id": "wheel-0096",
        "kind": "wheel",
        "name": "Silver Cod's Determination",
        "lineupToken": "xP",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR20.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR20.webp"
        },
        "description": "Team Unique: The wielder switches to the Silver Cod Persona after exploration begins. They will switch between the Silver Cod and Cat Personas after using Exalt. Silver Cod: Gain 40 Keyflare after dealing Active DMG. Cat: Gain a Temporary Crit. DMG increase of +4% after dealing Active DMG. These effects share a maximum of 5 triggers per turn.",
        "aliases": [],
        "searchTags": [
          "Keyflare",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "24"
      },
      {
        "id": "wheel-0097",
        "kind": "wheel",
        "name": "Til the Snow Melts",
        "lineupToken": "xZ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR21.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR21.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +15%. At battle start, the wielder gains 25 stacks of \"Snow\". Playing a card grants 2 Aliemus and removes 1 stack. Once all \"Snow\" stacks are removed, the wielder gains 20% Crit. Rate.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Helot: Catena"
      },
      {
        "id": "wheel-0098",
        "kind": "wheel",
        "name": "Deep Sea's Call",
        "lineupToken": "xQ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR22.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR22.webp"
        },
        "description": "Team Unique: After battle start, gain STR equal to 8% of the wielder's ATK. If the current realm is Aequor, also increase Tentacle DMG by 8% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Tentacle DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Miryam"
      },
      {
        "id": "wheel-0099",
        "kind": "wheel",
        "name": "Kiss of Farewell",
        "lineupToken": "xS",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR23.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR23.webp"
        },
        "description": "Team Unique: After the wielder releases Exalt, they gain STR equal to 3% of the wielder's ATK. If the current Realm is Caro, after releasing Exalt, Embryo Fusion +10.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Thais"
      },
      {
        "id": "wheel-0100",
        "kind": "wheel",
        "name": "Poetic Bygone Days",
        "lineupToken": "xR",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR24.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR24.webp"
        },
        "description": "Team Unique: At battle start, draw 1 Command Card of the wielder and have a 100% chance to reduce its Arithmetica Cost by 1. Each time Death Resistance is triggered, this effect is repeated once.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Death Resistance",
          "Draw"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Horla"
      },
      {
        "id": "wheel-0101",
        "kind": "wheel",
        "name": "Million Loving Gaze",
        "lineupToken": "xU",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR25.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR25.webp"
        },
        "description": "Team Unique: The wielder's DMG Dealt +12% of the wielder's ATK. If the current Realm is Caro, each time Devour is triggered, the wielder's DMG Dealt is further increased by 3% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Sorel"
      },
      {
        "id": "wheel-0102",
        "kind": "wheel",
        "name": "Slumber Beneath the Glacier",
        "lineupToken": "x4",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR26.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR26.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +10%. After unleashing Posse, all Awakeners gain 10% Temporary Crit. Rate and Crit. DMG, but incur a Sacrifice of 3% of Max HP. If the current Realm is Aequor, unleashing Posse also increases Tentacle DMG by 3% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [
          "Tentacle DMG",
          "Shield",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Murphy"
      },
      {
        "id": "wheel-0103",
        "kind": "wheel",
        "name": "Fate Roulette",
        "lineupToken": "x3",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR27.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR27.webp"
        },
        "description": "Team Unique: Increases the wielder's Crit. Rate by 8%. Gain 6 Black Sigil upon killing an enemy, up to 3 times during exploration. After 3 triggers, the wielder's Crit. Rate permanently +6% for the rest of the exploration.",
        "aliases": [],
        "searchTags": [
          "Crit Rate",
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Ryker"
      },
      {
        "id": "wheel-0104",
        "kind": "wheel",
        "name": "Gateway of Truth",
        "lineupToken": "x5",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR28.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR28.webp"
        },
        "description": "Team Unique: After the battle begins, gain Keyflare equal to 500% of the wielder's Keyflare Regen. After the first time you release a Posse in each battle, this effect triggers again.",
        "aliases": [],
        "searchTags": [
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Tawil"
      },
      {
        "id": "wheel-0105",
        "kind": "wheel",
        "name": "Never-Ending Performance",
        "lineupToken": "x2",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR29.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR29.webp"
        },
        "description": "Team Unique: At turn end, the wielder gains 5 Aliemus. After the wielder releases Exalt, the next Command Card played by the wielder this turn increases its Crit. Rate, Crit. DMG, Shield, and health recovery by 20%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal",
          "Aliemus",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Hameln"
      },
      {
        "id": "wheel-0106",
        "kind": "wheel",
        "name": "Shepherd's Staff",
        "lineupToken": "x1",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR30.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR30.webp"
        },
        "description": "Team Unique: At battle start, the wielder gains Aliemus equal to 100% of the wielder's Aliemus Regen. After the wielder releases Exalt for the first time in each battle, this effect repeats once.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Doll: Inferno"
      },
      {
        "id": "wheel-0107",
        "kind": "wheel",
        "name": "Blue Stone Throne",
        "lineupToken": "x7",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR31.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR31.webp"
        },
        "description": "Team Unique: At battle start, grant the \"Immortal Dominion\" effect to all Command Cards in the Draw Pile with Arithmetica consumption greater than or equal to 3. This card has the Retain effect. After being played, all Awakeners temporarily increase their Crit. Rate by 10% and remove \"Immortal Dominion.\" If the current Realm is Aequor, gain 1 Arithmetica after \"Immortal Dominion\" is removed.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Tulu"
      },
      {
        "id": "wheel-0109",
        "kind": "wheel",
        "name": "Macabre Delicacies",
        "lineupToken": "yK",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR33.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR33.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +15%. If the current Realm is Caro, whenever the wielder kills an enemy, accumulate Crimson Furnace equal to 20% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Doresain"
      },
      {
        "id": "wheel-0110",
        "kind": "wheel",
        "name": "Witch's Wide-brimmed Hat",
        "lineupToken": "x8",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR34.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR34.webp"
        },
        "description": "Team Unique: The Base DMG dealt by the first Command Card used by the wielder each turn +60%. If they enter the Ultra Space, the wielder gains 8 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Daffodil"
      },
      {
        "id": "wheel-0111",
        "kind": "wheel",
        "name": "Blue-Ringed Toxin",
        "lineupToken": "yM",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR35.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR35.webp"
        },
        "description": "Team Unique: The wielder's Keyflare Regen, Exalt Final DMG & Shield +8%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Murphy: Fauxborn"
      },
      {
        "id": "wheel-0112",
        "kind": "wheel",
        "name": "Lone Feather",
        "lineupToken": "yq",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR39.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR39.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +12%. At turn end, gain Shield equal to 10% of the wielder's DEF, which +2% of the wielder's DEF per turn.",
        "aliases": [],
        "searchTags": [
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Castor"
      },
      {
        "id": "wheel-0113",
        "kind": "wheel",
        "name": "The Divus' Visage",
        "lineupToken": "yD",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR40.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR40.webp"
        },
        "description": "Team Unique: In the Ultra Round: Gain 3 stacks of Alight. When the wielder plays a Command Card, consume 1 stack to increase its Final DMG and Shield Generation by 15%.",
        "aliases": [],
        "searchTags": [
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Pollux"
      },
      {
        "id": "wheel-0114",
        "kind": "wheel",
        "name": "Navigator at Sea",
        "lineupToken": "yv",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR41.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR41.webp"
        },
        "description": "Team Unique: At battle start, gain Shield equal to 30% of the wielder's DEF. After triggering Death Resistance, trigger this effect again At next turn start.",
        "aliases": [],
        "searchTags": [
          "Death Resistance",
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Corposant"
      },
      {
        "id": "wheel-0115",
        "kind": "wheel",
        "name": "Thirsting Brush",
        "lineupToken": "yt",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR42.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR42.webp"
        },
        "description": "Team Unique: After the wielder unleashes Exalt, they gain 1 stack of Collaboration. The next Exalt of other Awakeners this turn can consume Collaboration, increasing its Crit. Rate by 25%, and the Awakener consuming Collaboration gains Aliemus equal to 25% the wielder's Aliemus Regen.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": "Pickman"
      },
      {
        "id": "wheel-0116",
        "kind": "wheel",
        "name": "Impending Sun",
        "lineupToken": "yE",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR43.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR43.webp"
        },
        "description": "Team Unique: The wielder's Base DMG +15%. After playing 5 of the wielder's Command Cards, the wielder gains 20% Temporary Crit. Rate. This effect can only trigger once per turn.",
        "aliases": [],
        "searchTags": [
          "Crit Rate"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Kathigu-Ra"
      },
      {
        "id": "wheel-0117",
        "kind": "wheel",
        "name": "Light of Intellect",
        "lineupToken": "yI",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR44.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR44.webp"
        },
        "description": "Team Unique: After the first Posse release in each turn, there is a 100% chance to draw 1 \"Strike\" of the wielder's.",
        "aliases": [],
        "searchTags": [
          "Draw",
          "Strike"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": "Mouchette"
      },
      {
        "id": "wheel-0118",
        "kind": "wheel",
        "name": "Magnolia's Lure",
        "lineupToken": "yQ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR45.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR45.webp"
        },
        "description": "Team Unique: The wielder's Fixed Poison Infliction and Poison Trigger +10%. The wielder gains 10 Aliemus the first time they trigger Resonance each turn.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Xu"
      },
      {
        "id": "wheel-0119",
        "kind": "wheel",
        "name": "Imprisoned Madness",
        "lineupToken": "yW",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR46.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR46.webp"
        },
        "description": "Team Unique: When switching to the Raging Waves stance, gain Temporary Realm Mastery equal to 20% of your current Realm Mastery. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Temporary Realm Mastery"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Vortice"
      },
      {
        "id": "wheel-0120",
        "kind": "wheel",
        "name": "Spring in Yakutsk",
        "lineupToken": "u",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL01.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL01.webp"
        },
        "description": "Team Unique: At turn end, the wielder gains 15 Aliemus and Keyflare equal to their Keyflare Regen.",
        "aliases": [],
        "searchTags": [
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0121",
        "kind": "wheel",
        "name": "Sunfall",
        "lineupToken": "N",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL02.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL02.webp"
        },
        "description": "Team Unique: The wielder's Base DMG, Poison, and Counter +20%. Crit. Rate and Crit. DMG +20%.",
        "aliases": [],
        "searchTags": [
          "Poison",
          "Counter",
          "Crit Rate",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0122",
        "kind": "wheel",
        "name": "Birth of a Soul",
        "lineupToken": "O",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL03.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL03.webp"
        },
        "description": "Team Unique: The team's Max HP +10%. The wielder's HP Recovery and Shield Generation +10%. After playing the wielder's \"Strike,\" restore 6% of lost HP. After playing the wielder's \"Defense,\" gain Shield equal to 6% of current HP. Each effect can trigger up to 1 time per turn.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal",
          "Strike",
          "Defense"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0123",
        "kind": "wheel",
        "name": "Dusk and Dawn",
        "lineupToken": "xT",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL04.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL04.webp"
        },
        "description": "Team Unique: Gain 200 Keyflare at turn end. Gain 1000 Keyflare after triggering Death Resistance. Using Emergency Gnosis increases Arithmetica Limit by 3 and allows you to draw 3 cards per turn.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Death Resistance",
          "Draw",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "DEATH_RESISTANCE",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0124",
        "kind": "wheel",
        "name": "Heart of Silver",
        "lineupToken": "x6",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL05.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL05.webp"
        },
        "description": "Team Unique: Upon unleashing Posse, gain 3% of the wielder's ATK as STR and Shield equal to 15% of their DEF. Upon using an Emergency Gnosis, all Awakeners gain 30 Aliemus at turn end.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0125",
        "kind": "wheel",
        "name": "Annihilated Rebirth",
        "lineupToken": "yF",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL06.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL06.webp"
        },
        "description": "Team Unique: After the wielder releases Exalt, Exalt Base DMG +10%, Shield and HP Recovery +5%, stacking up to 5 times. During exploration, the Affinity gained by the wielder +25%.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Heal"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0126",
        "kind": "wheel",
        "name": "We Will Meet Again",
        "lineupToken": "yN",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL07.webp"
        },
        "description": "Team Unique: After switching Tentacle Stances, using Crimson Furnace, or unleashing Annihilation, draw the wielder's Command Card ×1; each effect has a cooldown of 3 turns. After the Exploration, all Awakeners in the team gain +10% Affinity.",
        "aliases": [],
        "searchTags": [
          "Draw"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0128",
        "kind": "wheel",
        "name": "Eternal Weave",
        "lineupToken": "yi",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_D10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_D10.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +25%, and when the wielder uses Pursuit, Temporary Amplification +40%, up to 5 times per turn. Whenever Dimension Shuttle is triggered, the wielder gains 10 Aliemus.",
        "aliases": [],
        "searchTags": [
          "Pursuit",
          "Shield",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "ULTRA",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Arachne"
      },
      {
        "id": "wheel-0130",
        "kind": "wheel",
        "name": "Private Afternoon",
        "lineupToken": "yY",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP12.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP12.webp"
        },
        "description": "Team Unique: After exploration starts, shuffle 1 derived:Private Afternoon into the Draw Pile. derived:Private Afternoon: Consume 1 Arithmetica. Temporary Crit. DMG +80%. Retain. Exhaust.",
        "aliases": [],
        "searchTags": [
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0131",
        "kind": "wheel",
        "name": "Uteri Somnia",
        "lineupToken": "yp",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O02EX.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O02EX.webp"
        },
        "description": "Team Unique: Hand Limit +2. <Italic:(Does not stack with other Wheels.)> The wielder's Keyflare Regen and their Exalt's Final DMG & Shield Generation +20%. Upon switching to the Tranquil Sea stance, the wielder gains 30 Aliemus. 3-turn cooldown. Upon switching to the Raging Waves stance, inflict 10 stacks of Birth Ritual on all enemies. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Shield",
          "Hand Limit",
          "Keyflare",
          "Aliemus"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Murphy: Fauxborn"
      },
      {
        "id": "wheel-0132",
        "kind": "wheel",
        "name": "Rota Fortunae",
        "lineupToken": "yu",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR36.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR36.webp"
        },
        "description": "Team Unique: The wielder's Shield Generation +10%, and when the wielder uses Pursuit, Temporary Amplification +15%, up to 5 times per turn.",
        "aliases": [],
        "searchTags": [
          "Pursuit",
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Arachne"
      },
      {
        "id": "wheel-0136",
        "kind": "wheel",
        "name": "Greed",
        "lineupToken": "xB",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_P15.webp",
          "full": "./generated-assets/wheels/Weapon_Full_P15.webp"
        },
        "description": "Team Unique: After each stage starts, gain 30 Black Sigils. Relic Capacity +2. In Astral Reign, this effect changes to \"Increases the chance for the wielder's Dimensional Image Relic to appear by 100%.\"",
        "aliases": [],
        "searchTags": [
          "Sigil Gain"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "R",
        "mainstatKey": "ALIEMUS_REGEN",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0137",
        "kind": "wheel",
        "name": "Hypnotic Pendulum",
        "lineupToken": "x0",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR32.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR32.webp"
        },
        "description": "Team Unique: Increases the wielder's Keyflare Regen by 10%. At the start of the first battle, inflict 1 stack of Weakness and Vulnerable on all enemies.",
        "aliases": [],
        "searchTags": [
          "Weakness",
          "Vulnerable",
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "KEYFLARE_REGEN",
        "ownerAwakenerName": "Clementine"
      },
      {
        "id": "wheel-0165",
        "kind": "wheel",
        "name": "Sakura Reveries",
        "lineupToken": "yZ",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP07.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP07.webp"
        },
        "description": "Team Unique: After the exploration starts, shuffle 1 Vernal Message into the deck: Arithmetica Cost 1, gain 250 Keyflare, permanently transforms into Sakura Blossoms after played: Arithmetica Cost 1, gain 500 Keyflare, after playing it permanently transforms into Hanafubuki: Arithmetica Cost 1, gain 750 Keyflare, permanently transforms into Ichigo Ichie after played: Arithmetica Cost 1, choose 1 from 3 random unlocked Posse to immediately unleash and trigger 2 times, permanently transforms into Vernal Message after played. All of these cards have Retain.",
        "aliases": [],
        "searchTags": [
          "Keyflare"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0166",
        "kind": "wheel",
        "name": "To the Stars",
        "lineupToken": "y1",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_ZL08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_ZL08.webp"
        },
        "description": "Team Unique: For every 1% of Sigil Yield the wielder, their WoDs, and Covenants have, recover 0.3% Max HP at the end of battle. This effect diminishes by 30% at the end of every turn, and is calculated individually for each battle. After choosing Perception at Ashen Ruins, refreshes will be free at this Ashen Ruins before you leave.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Heal",
          "Sigil Yield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0167",
        "kind": "wheel",
        "name": "Fragrant Morphogenesis",
        "lineupToken": "yU",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B15.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B15.webp"
        },
        "description": "Team Unique: Arithmetica Limit +1. Effects of the same type cannot stack. For every 10 Base Aliemus the wielder has, they inflict +5% Corrosion stacks and cause +1.5% Embryo Fusion.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Saya"
      },
      {
        "id": "wheel-0168",
        "kind": "wheel",
        "name": "Muddied Fairy Tale",
        "lineupToken": "yT",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR49.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR49.webp"
        },
        "description": "Team Unique: After using Crimson Furnace, the wielder gains Aliemus equal to 10% of Base Aliemus. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Saya"
      },
      {
        "id": "wheel-0169",
        "kind": "wheel",
        "name": "Compass to False North",
        "lineupToken": "y2",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR50.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR50.webp"
        },
        "description": "Team Unique: The wielder's STR▼ effect +15%. After switching to the Raging Waves stance, Temporary Crit. DMG increases by an amount equal to 15% of the wielder's Base Crit. DMG, 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Pontos"
      },
      {
        "id": "wheel-0170",
        "kind": "wheel",
        "name": "Dreaming of Wonderland",
        "lineupToken": "y4",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP08.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP08.webp"
        },
        "description": "Team Unique: After exploration starts, add 1 derived:Dreaming of Wonderland to the deck. derived:Dreaming of Wonderland: Consume 2 Arithmetica, grant the wielder 50 Aliemus and 3 stacks of Mental Interference. Retain. Exhaust.",
        "aliases": [],
        "searchTags": [
          "Aliemus"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "DMG_AMP",
        "ownerAwakenerName": "Lily"
      },
      {
        "id": "wheel-0171",
        "kind": "wheel",
        "name": "The Living Cage",
        "lineupToken": "y3",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_O13.webp",
          "full": "./generated-assets/wheels/Weapon_Full_O13.webp"
        },
        "description": "Team Unique: The wielder's STR▼ Infliction +35%. For the current exploration, each kill increases the wielder's Fixed Aliemus recovery at turn end by 2, stacking up to 10 times. After switching to the Raging Waves stance, Temporary Crit. DMG increases by an amount equal to 35% of the wielder's Base Crit. DMG, 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "AEQUOR",
        "rarity": "SSR",
        "mainstatKey": "CRIT_DMG",
        "ownerAwakenerName": "Pontos"
      },
      {
        "id": "wheel-0172",
        "kind": "wheel",
        "name": "Cetus Occasus",
        "lineupToken": "y9",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C04EX.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C04EX.webp"
        },
        "description": "Team Unique: The wielder's \"Strike\" Crit. DMG +75%. At the end of each turn, the wielder's next Exalt Crit. DMG is increased by a percentage equal to 20% of their Base Aliemus, stacking up to 5 times.",
        "aliases": [],
        "searchTags": [
          "Aliemus",
          "Strike",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Lotan: Cetarchon"
      },
      {
        "id": "wheel-0173",
        "kind": "wheel",
        "name": "Undying Hungerbone",
        "lineupToken": "y8",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR47.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR47.webp"
        },
        "description": "Team Unique: The wielder's \"Strike\" Crit. DMG +50%.",
        "aliases": [],
        "searchTags": [
          "Strike",
          "Crit DMG"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": "Lotan: Cetarchon"
      },
      {
        "id": "wheel-0174",
        "kind": "wheel",
        "name": "Falling Upward",
        "lineupToken": "y7",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP09.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP09.webp"
        },
        "description": "Team Unique: At the start of exploration, add 1 derived:Mortal Sojourn to the deck. Mortal Sojourn (Costs 0 Arithmetica): Inflict Fixed Corrosion on all enemies equal to 3000% of the wielder's ATK plus 1% of their Max HP. Then, apply Perception Warp to the Command Cards of all other Awakeners on the field, and shuffle 1 derived:Falling Upward into the Draw Pile. Retain. Exhaust",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0175",
        "kind": "wheel",
        "name": "Honeyed Deceit",
        "lineupToken": "yj",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_B11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_B11.webp"
        },
        "description": "Team Unique: The wielder's Exalt generates +40% Base Shield. After the wielder plays a Command Card that inflicts Weakness, their next Command Card generates +40% Base Shield. Upon using Crimson Furnace, draw the wielder's Skill Card with the highest Arithmetica Cost and Embryo Fusion +40. 3-turn cooldown.",
        "aliases": [],
        "searchTags": [
          "Weakness",
          "Shield",
          "Embryo Fusion"
        ],
        "selectable": true,
        "realm": "CARO",
        "rarity": "SSR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Caraboo"
      },
      {
        "id": "wheel-0176",
        "kind": "wheel",
        "name": "Serene Truth",
        "lineupToken": "yA",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR37.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR37.webp"
        },
        "description": "Team Unique: After the wielder plays a Command Card that inflicts Weakness, the Base Shield generated by the next equipment Command Card +40. Cannot stack.",
        "aliases": [],
        "searchTags": [
          "Weakness",
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "REALM_MASTERY",
        "ownerAwakenerName": "Caraboo"
      },
      {
        "id": "wheel-0177",
        "kind": "wheel",
        "name": "Soul Synchronization",
        "lineupToken": "zb",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP10.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP10.webp"
        },
        "description": "Team Unique: At the start of exploration, add 1 Soul Synchronization to your deck. derived:Soul Synchronization (0 Arithmetica Cost): Gain 1 Arithmetica when played. Retain: While in hand, this card accumulates Fixed HP Recovery (equal to 6% of the wielder's CON) and 4 Fixed Aliemus per turn. If the wielder takes fatal damage, this card prevents their death, releases all stored HP and Aliemus to them, and is then Destroyed.",
        "aliases": [],
        "searchTags": [
          "Arithmetica",
          "Heal"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "SIGIL_YIELD",
        "ownerAwakenerName": null
      },
      {
        "id": "wheel-0178",
        "kind": "wheel",
        "name": "Ever Sunward",
        "lineupToken": "zc",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_C03EX.webp",
          "full": "./generated-assets/wheels/Weapon_Full_C03EX.webp"
        },
        "description": "Team Unique: The wielder's \"Exalt\" generates +30% Base Shield and Fixed STR. The wielder's \"Defense\" generates +50% Base Shield. After the wielder plays \"Defense,\" gain STR equal to 5% of the wielder's ATK.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield",
          "Defense"
        ],
        "selectable": true,
        "realm": "CHAOS",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Ogier: Oathbound"
      },
      {
        "id": "wheel-0179",
        "kind": "wheel",
        "name": "Shadowed by the Past",
        "lineupToken": "zd",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_SR51.webp",
          "full": "./generated-assets/wheels/Weapon_Full_SR51.webp"
        },
        "description": "Team Unique: The wielder's \"Exalt\" generates +15% Base Shield and Fixed STR.",
        "aliases": [],
        "searchTags": [
          "STR Up",
          "Shield"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": "Ogier: Oathbound"
      },
      {
        "id": "wheel-0180",
        "kind": "wheel",
        "name": "Darker than Darkness",
        "lineupToken": "ze",
        "assets": {
          "thumb": "./generated-assets/wheels/Mini/Weapon_Mini_JP11.webp",
          "full": "./generated-assets/wheels/Weapon_Full_JP11.webp"
        },
        "description": "Team Unique: At the start of exploration, add 1 Fall into Night card to the deck.",
        "aliases": [],
        "searchTags": [
          "Draw",
          "Aliemus",
          "Strike"
        ],
        "selectable": true,
        "realm": "NEUTRAL",
        "rarity": "SSR",
        "mainstatKey": "CRIT_RATE",
        "ownerAwakenerName": null
      }
    ],
    "covenants": [
      {
        "id": "covenant-0001",
        "kind": "covenant",
        "name": "Deus Ex Machina",
        "lineupToken": "k",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_001.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_001.webp"
        },
        "description": "3-set: Realm Mastery +12 6-set: Gain 1 Arithmetica in the first turn of each battle, and gain an additional 1 Arithmetica every 4 turns during boss battles.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: City of Big Smoke"
      },
      {
        "id": "covenant-0002",
        "kind": "covenant",
        "name": "Re-evolution",
        "lineupToken": "m",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_002.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_002.webp"
        },
        "description": "3-set: Aliemus Regen Lv. +2.4 6-set: Team Unique: Gain 35 Aliemus at the start of exploration. After the wielder uses Exalt, gain 2 Aliemus at the end of each turn for the rest of the battle. This effect can stack up to 3 times.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - D-Jewel Exchange"
      },
      {
        "id": "covenant-0003",
        "kind": "covenant",
        "name": "Scarlet Embrace",
        "lineupToken": "t",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_004.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_004.webp"
        },
        "description": "3-set: Crit. Rate +4.8% 6-set: The wielder gains 35 Keyflare when dealing DMG, or 70 Keyflare for Crit. DMG. This effect can trigger up to 3 times per turn.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Sediment Exchange"
      },
      {
        "id": "covenant-0004",
        "kind": "covenant",
        "name": "Crimson Pulse",
        "lineupToken": "h",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_005.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_005.webp"
        },
        "description": "3-set: Crit. DMG +7.2% 6-set: After unleashing Posse, the wielder gains 30% Temporary Crit. Rate.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Investigation Exchange"
      },
      {
        "id": "covenant-0005",
        "kind": "covenant",
        "name": "Twisted Twins: Black",
        "lineupToken": "B",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_006.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_006.webp"
        },
        "description": "3-set: Crit. Rate +4.8% 6-set: At the start of odd turns, add the wielder's \"Strike\" with Fleeting and Exhaust to your hand.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Town of Madness"
      },
      {
        "id": "covenant-0006",
        "kind": "covenant",
        "name": "Burial Ground's Sighs",
        "lineupToken": "D",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_008.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_008.webp"
        },
        "description": "3-set: Death Resistance +16.8% 6-set: At the start of the level, Death Resistance +25%. After triggering Death Resistance, the wielder gains 50 Aliemus.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Distorted Mountains"
      },
      {
        "id": "covenant-0007",
        "kind": "covenant",
        "name": "Twisted Twins: White",
        "lineupToken": "s",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_009.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_009.webp"
        },
        "description": "3-set: Death Resistance +16.8% 6-set: Even-numbered turn starts: Add the wielder's \"Defense\" with Fleeting and Exhaust to your hand.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Frenzied Wax Museum"
      },
      {
        "id": "covenant-0008",
        "kind": "covenant",
        "name": "Cursed Rabbit",
        "lineupToken": "e",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_010.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_010.webp"
        },
        "description": "3-set: Realm Mastery +12 6-set: The wielder's Shield Generation and HP Recovery +12%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - D-Jewel Exchange"
      },
      {
        "id": "covenant-0009",
        "kind": "covenant",
        "name": "Paradox",
        "lineupToken": "f",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_011.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_011.webp"
        },
        "description": "3-set: Keyflare Regen Lv. +7.2 6-set: Team Unique: Increases the wielder's Base Aliemus by 20. Increases Crit. Rate, Crit. DMG, Shield, and HP Recovery of the wielder's Command Cards by 20%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Sediment Exchange"
      },
      {
        "id": "covenant-0010",
        "kind": "covenant",
        "name": "Photosynthesis Ritual",
        "lineupToken": "l",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_012.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_012.webp"
        },
        "description": "3-set: DMG Amplification +7.2% 6-set: Team Unique: After one of the wielder's Command Cards enters Ultra Space, Embryo Fusion +25~50. The lower your current HP, the more Embryo Fusion is gained.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Investigation Exchange"
      },
      {
        "id": "covenant-0011",
        "kind": "covenant",
        "name": "Returnal Line",
        "lineupToken": "d",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_013.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_013.webp"
        },
        "description": "3-set: Realm Mastery +12 6-set: Team Unique: At battle start, the wielder gains STR equal to 12% of their own ATK. If the current Realm is Aequor, instead gain the following effect: \"At the start of each turn, there is a (50 + 0.25 × the team's Realm Mastery)% chance to gain 1 stack of Tentacle Gathering. If this chance exceeds 100%, multiple stacks can be gained. This chance is doubled in Boss Battles.\"",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: The Outer Sea"
      },
      {
        "id": "covenant-0012",
        "kind": "covenant",
        "name": "Ring of Chamber 36",
        "lineupToken": "r",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_014.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_014.webp"
        },
        "description": "3-set: Aliemus Regen Lv. +2.4 6-set: Team Unique. Keyflare Limit and Posse Keyflare Cost +200. Exalt Crit. Rate, Crit. DMG, Shield, and HP Recovery +30%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Lightless Exchange"
      },
      {
        "id": "covenant-0013",
        "kind": "covenant",
        "name": "Life Drain",
        "lineupToken": "n",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_015.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_015.webp"
        },
        "description": "3-set: Keyflare Regen Lv. +7.2 6-set: Team Unique: at turn end, gain Keyflare equal to 200% of the wielder's Keyflare Regen. If the current Realm is Caro, the effect changes to: for every 5 points of Keyflare Regen, Embryo Fusion +1.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Wall of Desert Sands"
      },
      {
        "id": "covenant-0014",
        "kind": "covenant",
        "name": "April Tribute",
        "lineupToken": "b",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_016.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_016.webp"
        },
        "description": "3-set: Crit. DMG +7.2% 6-set: Team Unique: At turn start, if the enemies' total HP is above 75%, the wielder's Temporary Crit. Rate and Crit. DMG increase by 35%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Prime Fissure"
      },
      {
        "id": "covenant-0015",
        "kind": "covenant",
        "name": "Organic Form",
        "lineupToken": "g",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_017.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_017.webp"
        },
        "description": "3-set: Sigil Yield +3.6% 6-set: Team Unique. At the start of exploration, reduce up to 100% Death Resistance. For every 1% of Death Resistance reduced, the wielder's Aliemus Generation +0.15%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Rose Scrip Exchange"
      },
      {
        "id": "covenant-0016",
        "kind": "covenant",
        "name": "Sweet Slug",
        "lineupToken": "p",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_018.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_018.webp"
        },
        "description": "3-set: Death Resistance +25.2% 6-set: Team Unique. If Annihilation is unleashed and the Tentacle Stance is switched within 1 turn, the wielder's Shield, HP Recovery, and Final DMG +25% this turn, 3-turn cooldown.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Investigation Exchange"
      },
      {
        "id": "covenant-0017",
        "kind": "covenant",
        "name": "Dream of Medicine",
        "lineupToken": "o",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_019.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_019.webp"
        },
        "description": "3-set: DMG Amplification +4.8% 6-set: Team Unique: Lose 8 Black Sigils after the battle ends. At battle start, shuffle 1 Basic Copy of each of the wielder's Command Cards, except Strike and Defense, into the Draw Pile.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Investigation Exchange"
      },
      {
        "id": "covenant-0018",
        "kind": "covenant",
        "name": "Feast from Afar",
        "lineupToken": "A",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_020.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_020.webp"
        },
        "description": "3-set: Sigil Yield +3.6% 6-set: At exploration start, gain 10 Black Sigils. The wielder's \"Defense\" Shield Generation +60%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Lightless Exchange"
      },
      {
        "id": "covenant-0019",
        "kind": "covenant",
        "name": "Unstained Chronicle",
        "lineupToken": "v",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_021.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_021.webp"
        },
        "description": "3-set: Keyflare Regen Lv. +7.2 6-set: Team Unique: After using Posse, recover HP equal to 12% of the wielder's CON, increasing with the percentage of lost HP, up to 24% of the wielder's CON.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Clear Interlude - Verboten Covenant: Ship of the Dark Sea"
      },
      {
        "id": "covenant-0020",
        "kind": "covenant",
        "name": "Steppenwolf",
        "lineupToken": "w",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_022.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_022.webp"
        },
        "description": "3-set: DMG Amplification +4.8% 6-set: The wielder's Base DMG +20%, and Poison Infliction and Counter Generation +10%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Rose Scrip Exchange"
      },
      {
        "id": "covenant-0021",
        "kind": "covenant",
        "name": "Cocoon of the Maiden",
        "lineupToken": "C",
        "assets": {
          "thumb": "./generated-assets/covenants/Icon/Icon_Trinket_023.webp",
          "full": "./generated-assets/covenants/FullArt/Icon_Trinket_023.webp"
        },
        "description": "3-set: Crit. Rate +7.2% 6-set: Team Unique. The wielder gains 8% Temporary Crit. DMG for each Tentacle after consuming an Embryo for the first time each turn, up to 80%.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "acquisitionSource": "Purchase from Mythag Shop - Investigation Exchange"
      }
    ],
    "posses": [
      {
        "id": "posse-0001",
        "kind": "posse",
        "name": "Encounter in Pure White",
        "lineupToken": "d",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_01.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_01.webp"
        },
        "description": "Discard your hand, then draw that many cards plus 2.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 3 - Beware of Hounds"
      },
      {
        "id": "posse-0002",
        "kind": "posse",
        "name": "Voices in Your Head",
        "lineupToken": "h",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_02.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_02.webp"
        },
        "description": "Inflict 1 stack of Weakness and Vulnerable on each enemy, and Steal Arg1 STR from them.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Automatically Unlocked"
      },
      {
        "id": "posse-0003",
        "kind": "posse",
        "name": "Warded Injection",
        "lineupToken": "b",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_03.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_03.webp"
        },
        "description": "Gain Arg1 Shield. If current HP is below 25%, recover Arg2 HP.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 4 - Where Silence Reigns"
      },
      {
        "id": "posse-0004",
        "kind": "posse",
        "name": "A Mouse's Wisdom",
        "lineupToken": "c",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_04.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_04.webp"
        },
        "description": "Gain 3 Arithmetica.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 2 - Waxen Legacy"
      },
      {
        "id": "posse-0005",
        "kind": "posse",
        "name": "Tiny Wish",
        "lineupToken": "i",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_05.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_05.webp"
        },
        "description": "Grant a chosen Awakener Arg1 Aliemus. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 1 - East District's Enigma"
      },
      {
        "id": "posse-0006",
        "kind": "posse",
        "name": "Obsession Eternal",
        "lineupToken": "g",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_06.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_06.webp"
        },
        "description": "Gain Arg1 STR, then gain Temporary STR equal to 25% of your Permanent STR. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 5 - Eye of the Storm"
      },
      {
        "id": "posse-0007",
        "kind": "posse",
        "name": "Unequal Exchange",
        "lineupToken": "e",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_07.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_07.webp"
        },
        "description": "Draw 4 cards.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Sediment Exchange"
      },
      {
        "id": "posse-0008",
        "kind": "posse",
        "name": "Funus Aeternum",
        "lineupToken": "f",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_08.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_08.webp"
        },
        "description": "Grant all Awakeners Arg1 Aliemus. Suffer a Delayed Sacrifice equal to 5% of your Max HP. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "FADED_LEGACY",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 6 - Twisted Stars"
      },
      {
        "id": "posse-0009",
        "kind": "posse",
        "name": "The Final Vow",
        "lineupToken": "l",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_09.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_09.webp"
        },
        "description": "Gain +Arg1 Temporary Crit. Rate and Arg2 Temporary STR. If in a Boss Battle and no cards have been played this turn, attempt to trigger Death Resistance 1 plural:1|time|times. If successful, gain Arg4 Shield. This effect can only trigger 1 plural:1|time|times per battle. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Psyche Deepdive: The Knight's Wish"
      },
      {
        "id": "posse-0010",
        "kind": "posse",
        "name": "Aurita's Treasure",
        "lineupToken": "j",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_10.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_10.webp"
        },
        "description": "Draw 3 plural:3|card|cards with the lowest Arithmetica Cost from the Draw Pile. If the Realm includes Aequor, gain Arg2 Tentacle DMG. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: Eadem Omnia"
      },
      {
        "id": "posse-0011",
        "kind": "posse",
        "name": "Roaring Blood and Sand",
        "lineupToken": "k",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_11.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_11.webp"
        },
        "description": "Grant a chosen Awakener Arg2 Aliemus. Gain Arg3 STR. If the Realm includes Caro, consume 10% of your HP to increase Embryo Fusion by +Arg4. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Psyche Deepdive: Blood and Sand"
      },
      {
        "id": "posse-0012",
        "kind": "posse",
        "name": "Ephemeral Eternity",
        "lineupToken": "m",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_12.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_12.webp"
        },
        "description": "Gain 1 Arithmetica. Choose an Awakener; create 1 of their Basic Strike and 1 of their Basic Defense. The copies have Exhaust and Fleeting. If the Realm includes Ultra, gain Arg2 Temp. STR and Arg3 Temp. Alert. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Psyche Deepdive: Twisted Core"
      },
      {
        "id": "posse-0013",
        "kind": "posse",
        "name": "Feast of Decay",
        "lineupToken": "q",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_13.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_13.webp"
        },
        "description": "Gain Arg1 Counter and temporarily inflict Arg2 STR▼ on all enemies. If in an Ultra Round, trigger 100% Counter against all enemies instead of inflicting STR▼. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Psyche Deepdive: Feast of Flames"
      },
      {
        "id": "posse-0014",
        "kind": "posse",
        "name": "Bone-Chilling Embrace",
        "lineupToken": "n",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_14.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_14.webp"
        },
        "description": "Gain 1 Arithmetica, and gain Arg2 Shield at next turn start. If your Tentacle Stance is Surging Tides, instead spawn 1 plural:1|Tentacle|Tentacles.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: Sculpted Like a Song"
      },
      {
        "id": "posse-0015",
        "kind": "posse",
        "name": "Lakeside Glimpse",
        "lineupToken": "o",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_15.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_15.webp"
        },
        "description": "Inflict Arg2 Poison on the highest HP enemy, and gain Arg1 Shield. If Devour has been triggered this turn, trigger that enemy's 50% Poison instead of gaining Shield. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Psyche Deepdive: Pale Descendant"
      },
      {
        "id": "posse-0016",
        "kind": "posse",
        "name": "Gateway of Retrospection",
        "lineupToken": "p",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_16.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_16.webp"
        },
        "description": "Search your Draw Pile for 1 plural:1|card|cards to put into hand, and reduce their Arithmetica Cost by 1.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Psyche Deepdive: One Step Away"
      },
      {
        "id": "posse-0017",
        "kind": "posse",
        "name": "Truth Behind Grey Mist",
        "lineupToken": "v",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_17.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_17.webp"
        },
        "description": "Gain Arg1 STR and create 1 derived:Insight. If in an Ultra Round, instead create 2 derived:Insight. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Special Ops: Phantom of the Rainy Town"
      },
      {
        "id": "posse-0018",
        "kind": "posse",
        "name": "Midsummer Vision",
        "lineupToken": "w",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_18.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_18.webp"
        },
        "description": "Draw 1 card; if the drawn card is a Command or Rouse card, reduce its Arithmetica Cost to 0 and grant its Awakener Arg1 Aliemus. Otherwise, discard that card and repeat this process. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Special Ops: The Magic of Stories"
      },
      {
        "id": "posse-0019",
        "kind": "posse",
        "name": "Victory of Roses",
        "lineupToken": "u",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_19.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_19.webp"
        },
        "description": "Draw 2 cards and gain Arg1 Temp. STR. If the Realm includes Caro, consume 10% of your HP to gain another Arg2 Temp. STR, and another Arg2 Temp. STR for each Embryo in your hand. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Special Ops: Tribute to the Rose"
      },
      {
        "id": "posse-0020",
        "kind": "posse",
        "name": "Miracle's Dawn",
        "lineupToken": "r",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_20.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_20.webp"
        },
        "description": "Gain Arg1 STR. Until your next turn, whenever you take Active DMG, gain Delayed Shield equal to 10% of that DMG. If the Realms includes Caro, instead accumulate Crimson Furnace equal to 10% of that DMG. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Special Ops: The Color of Blood"
      },
      {
        "id": "posse-0021",
        "kind": "posse",
        "name": "Giant's Reign",
        "lineupToken": "s",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_21.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_21.webp"
        },
        "description": "Gain 1 Arithmetica and Arg1 STR, then grant a chosen Awakener Arg2 Aliemus. If your Tentacle Stance is Raging Waves, instead gain +Arg3 Temporary Crit. Rate & Crit. DMG. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: The Fall of Giant"
      },
      {
        "id": "posse-0022",
        "kind": "posse",
        "name": "All of Her",
        "lineupToken": "t",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_22.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_22.webp"
        },
        "description": "Increase Realm Mastery by Arg1. Grant a chosen Awakener Arg2 Aliemus. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Special Ops: Serene Fission"
      },
      {
        "id": "posse-0023",
        "kind": "posse",
        "name": "The Lone Seed",
        "lineupToken": "G",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_23.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_23.webp"
        },
        "description": "Choose a non-Derived Command Card in hand and create a Basic Copy of it. The copy has Exhaust. Grant its Awakener Arg1 Aliemus. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 7 - Desire's Flow"
      },
      {
        "id": "posse-0024",
        "kind": "posse",
        "name": "The Mountains' Resolve",
        "lineupToken": "E",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_24.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_24.webp"
        },
        "description": "Choose an Awakener; draw 2 of their Command Cards.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Special Ops: Elworth's Returnee"
      },
      {
        "id": "posse-0025",
        "kind": "posse",
        "name": "Festival of Tides",
        "lineupToken": "C",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_25.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_25.webp"
        },
        "description": "Draw 2 cards. Gain 2 Arithmetica. All Awakeners lose 5 Aliemus. If your Tentacle Stance is Tranquil Sea, inflict Arg1 Poison on all enemies. Inflict 3× that much Poison instead in Boss Battles. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Dreamscape: Desecrate"
      },
      {
        "id": "posse-0026",
        "kind": "posse",
        "name": "Spring's Verse",
        "lineupToken": "A",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_26.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_26.webp"
        },
        "description": "Choose one of four Poetry Pages that haven't been chosen; reset after all Poems have been chosen.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Special Ops: Rose's Abode"
      },
      {
        "id": "posse-0027",
        "kind": "posse",
        "name": "A Gun's Cry",
        "lineupToken": "D",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_27.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_27.webp"
        },
        "description": "Create 1 Shining Octahedron Dice and gain Arg1 Temporary Crit. Rate. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Special Ops: Happy Hunting!"
      },
      {
        "id": "posse-0028",
        "kind": "posse",
        "name": "Symphony Fourth",
        "lineupToken": "I",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_28.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_28.webp"
        },
        "description": "If the Arithmetica Cost of the next card you play this turn is 3 or more, gain 2 Arithmetica. Otherwise, draw 2 cards. If this is the ordinal:4th time this Posse was unleashed this battle, instead create 4 derived:Insight.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 8 - Last Symphony"
      },
      {
        "id": "posse-0029",
        "kind": "posse",
        "name": "The Gated Answer",
        "lineupToken": "H",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_29.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_29.webp"
        },
        "description": "Discover 1 out of 3 random Posses, choose 1 and trigger its effect, and gain Arg1 Keyflare. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Operation: Faded Legacy - Ch. 9 - A Long Dream's End"
      },
      {
        "id": "posse-0030",
        "kind": "posse",
        "name": "Plague of Illusions",
        "lineupToken": "J",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_30.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_30.webp"
        },
        "description": "Grant a chosen Awakener Arg1 Aliemus, and inflict Arg2 Poison on each enemy. For each 1% of HP each enemy is missing, trigger 1% of their Poison, up to 50%. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 1 - Return to the Big Smoke"
      },
      {
        "id": "posse-0031",
        "kind": "posse",
        "name": "Blessing of the Stars",
        "lineupToken": "K",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_31.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_31.webp"
        },
        "description": "Choose either Slumber or Arouse.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: Coronation Day"
      },
      {
        "id": "posse-0032",
        "kind": "posse",
        "name": "Black Swan's Dance",
        "lineupToken": "B",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_32.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_32.webp"
        },
        "description": "Grant a chosen Awakener Arg2 Aliemus. The Crit. Rate & Crit. DMG of their Command Cards +Arg1 this turn. If Liz is in the team, create 1 derived:Corrupted Flames with Exhaust. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Psyche Deepdive: Passion to Dust"
      },
      {
        "id": "posse-0033",
        "kind": "posse",
        "name": "Tavern's Opening",
        "lineupToken": "L",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_33.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_33.webp"
        },
        "description": "Create 1 Leah's Coin and put it into the Discard Pile.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Clear Multiverse Link: My Turn!"
      },
      {
        "id": "posse-0034",
        "kind": "posse",
        "name": "Sacred Mending",
        "lineupToken": "M",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_34.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_34.webp"
        },
        "description": "Recover Arg1 HP and gain Arg2 STR. If Clementine is in the team, add 1 additional instance of the following effects to her next Command Card: DMG, Shield, HP Recovery, Aliemus, and Keyflare. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 2 - Metamorphosis"
      },
      {
        "id": "posse-0035",
        "kind": "posse",
        "name": "Undying Thunder",
        "lineupToken": "N",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_35.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_35.webp"
        },
        "description": "Gain Arg1 Shield. Draw 2 plural:2|card|cards. If Corposant is on the team, place 1 derived:Pilot into hand.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: Final Steersmanship"
      },
      {
        "id": "posse-0036",
        "kind": "posse",
        "name": "Derision of Destiny",
        "lineupToken": "O",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_36.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_36.webp"
        },
        "description": "Grant a chosen Awakener Arg3 Aliemus. Draw 2 plural:2|card|cards with the lowest Arithmetica Cost from the Draw Pile. If Castor is in the team, increase his Temp. DMG Amplification by Arg1. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Dreamscape: Beyond the Skies: Part I"
      },
      {
        "id": "posse-0037",
        "kind": "posse",
        "name": "Cruel Homage",
        "lineupToken": "S",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_39.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_39.webp"
        },
        "description": "Steal Arg1 STR from all enemies. If Doresain is in the team, he gains 1 Corpse.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 3 - Ossuary Gala"
      },
      {
        "id": "posse-0038",
        "kind": "posse",
        "name": "Undying Sun",
        "lineupToken": "R",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_40.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_40.webp"
        },
        "description": "Gain 1 Arithmetica and Arg1 Temp. DMG Amplification. If Kathigu-Ra is in the team, draw 1 of her Command Cards and apply 1 stack of Fiamma to it. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Psyche Deepdive: Everburning Vex"
      },
      {
        "id": "posse-0039",
        "kind": "posse",
        "name": "Sacred Bleeding Heart",
        "lineupToken": "V",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_41.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_41.webp"
        },
        "description": "Draw 1 card and reduce its Arithmetica Cost by 1. If a Command Card is drawn, its Awakener gains +Arg1 Temporary Crit. DMG. If Pollux is in the team, gain 5 plural:5|stack|stacks of Sin Mark. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Dreamscape: Beyond the Skies: Part II"
      },
      {
        "id": "posse-0040",
        "kind": "posse",
        "name": "Voracious Resolve",
        "lineupToken": "Q",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_42.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_42.webp"
        },
        "description": "Discover 1 of 3 basic Skill Commands from the Awakeners in the team, choose 1 and place its temporary copy in hand, and reduce its Arithmetica Cost by 1. If the Realm includes Caro, you may choose Gobble Up!",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Dreamscape: Culinary Dominion"
      },
      {
        "id": "posse-0041",
        "kind": "posse",
        "name": "Beachside Memento",
        "lineupToken": "T",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_43.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_43.webp"
        },
        "description": "Choose an Awakener; place 1 of their temporary basic \"Strike\" s with 0 cost into hand. Every ordinal:3rd time this is unleashed, instead place 1 derived:Fleeting Beauty into hand and gain +Arg1 Temp. Crit. Rate. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Clear Dreamscape: See You in Neverland"
      },
      {
        "id": "posse-0042",
        "kind": "posse",
        "name": "Void Hues",
        "lineupToken": "U",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_44.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_44.webp"
        },
        "description": "Grant a chosen Awakener Arg1 Aliemus, and shuffle 1 derived:Insight into the Draw Pile. If Pickman is in the team, he gains 1 stack of Creativity. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Psyche Deepdive: Ghastly Canvas"
      },
      {
        "id": "posse-0043",
        "kind": "posse",
        "name": "A Fleeting Dream",
        "lineupToken": "W",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_45.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_45.webp"
        },
        "description": "Gain Arg1 Shield and Temporary STR equal to 10% of your current Shield.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Clear Dreamscape: See You, Neverland"
      },
      {
        "id": "posse-0044",
        "kind": "posse",
        "name": "Wayward Ship",
        "lineupToken": "X",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_46.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_46.webp"
        },
        "description": "Gain 1 Arithmetica, and inflict 5 stacks of Birth Ritual on all enemies. If Murphy: Fauxborn is in the team, draw 1 Waltz of Lemuria.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 4 - Paradise"
      },
      {
        "id": "posse-0045",
        "kind": "posse",
        "name": "Reunion's Wish",
        "lineupToken": "Y",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_47.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_47.webp"
        },
        "description": "Return 1 Command Card from the Discard Pile to your hand. The next Ramona Command Card played this turn takes effect 2 plural:2|time|times.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Clear Special Ops: Celestial Aria"
      },
      {
        "id": "posse-0046",
        "kind": "posse",
        "name": "From the Mist Realm",
        "lineupToken": "Z",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_48.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_48.webp"
        },
        "description": "Draw 2 \"Strike\" s. If Mouchette is in the team, reduce their Arithmetica Cost by 1.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Multiverse Link: Baptism of Silver and Blood"
      },
      {
        "id": "posse-0047",
        "kind": "posse",
        "name": "Manor Echoes",
        "lineupToken": "2",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_49.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_49.webp"
        },
        "description": "Gain 1 Arithmetica and inflict Arg1 Temp. STR▼ on all enemies. If Xu is in the team, also inflict 1 stack of Spellbound on all enemies.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Psyche Deepdive: Whispers Behind the Fan"
      },
      {
        "id": "posse-0048",
        "kind": "posse",
        "name": "Year-End Sparks",
        "lineupToken": "3",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_50.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_50.webp"
        },
        "description": "Gain 1 Arithmetica and +Arg1 Temporary Crit. Rate. The first time this is unleashed each battle, inflict Arg3 Ancient Embers on all enemies. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "OTHER",
        "acquisitionSource": "Clear Special Ops: Spring Festival Express"
      },
      {
        "id": "posse-0049",
        "kind": "posse",
        "name": "Drowned Innocence",
        "lineupToken": "5",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_51.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_51.webp"
        },
        "description": "Grant a chosen Awakener Arg1 Aliemus, and all other Awakeners Arg2 Aliemus. If Vortice is in the team, she performs her Pursuit: derived:Vortex! Shell! Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: No More the Shore"
      },
      {
        "id": "posse-0050",
        "kind": "posse",
        "name": "Orbis Fatum",
        "lineupToken": "1",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_52.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_52.webp"
        },
        "description": "Gain Arg1 Shield and +Arg2 Temporary DMG Amplification. If Arachne is in the party, draw 1 Eternal Weave and reduce its Arithmetica Cost by 1. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "ULTRA",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 5 - Fated Theater"
      },
      {
        "id": "posse-0051",
        "kind": "posse",
        "name": "For the New World",
        "lineupToken": "4",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_53.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_53.webp"
        },
        "description": "Gain Arg1 Shield. Draw 2 \"Skill\" cards and grant them Perception Warp. Saya: gains 1 stack of Gynoecium.",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Multiverse Link: Forgotten Seed of Love"
      },
      {
        "id": "posse-0052",
        "kind": "posse",
        "name": "The Hollow One",
        "lineupToken": "6",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_54.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_54.webp"
        },
        "description": "Temporary Crit. DMG +Arg1, temporarily reduce all enemies' STR▼ by Arg2. If Pontos is in the party, gain 1 stack of Pack Hunt. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "AEQUOR",
        "acquisitionSource": "Clear Psyche Deepdive: Ebwynnos Evermore"
      },
      {
        "id": "posse-0053",
        "kind": "posse",
        "name": "Cetus-Devouring Storm",
        "lineupToken": "7",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_55.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_55.webp"
        },
        "description": "Gain Arg2 STR. Choose 1 Awakener to Steal up to 10 Aliemus from other Awakeners. If Lotan: Cetarchon is in the team, the next \"Strike\" of Lotan: Cetarchon takes effect 1 additional time. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Psyche Deepdive: Till the Cetus Falls"
      },
      {
        "id": "posse-0062",
        "kind": "posse",
        "name": "That Which is No Lie",
        "lineupToken": "8",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_56.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_56.webp"
        },
        "description": "Gain Arg1 Shield, increase Realm Mastery by Arg2. If Caraboo is in the team, the next Caraboo's derived:Caraboo's Blessing will not come with a Price. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CARO",
        "acquisitionSource": "Clear Operation: Astral Reign - Ch. 6 - When the Mountain Feasts"
      },
      {
        "id": "posse-0063",
        "kind": "posse",
        "name": "Pages Ever New",
        "lineupToken": "0",
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_57.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_57.webp"
        },
        "description": "Gain Arg1 Shield, gain Arg2 STR. If Ogier: Oathbound is in the team, Ogier: Oathbound gains Arg3 Aliemus and gains 1 stack of Undertow. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": true,
        "realm": "CHAOS",
        "acquisitionSource": "Clear Psyche Deepdive: The Pentameron"
      },
      {
        "id": "posse-0054",
        "kind": "posse",
        "name": "Primordial Memory: Drain",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Temporarily reduce all enemies' STR▼ by Arg1. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0055",
        "kind": "posse",
        "name": "Primordial Memory: Catalysis",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "All Awakeners gain Arg1 Aliemus. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0056",
        "kind": "posse",
        "name": "Primordial Memory: Healing",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Restore Arg1 HP Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0057",
        "kind": "posse",
        "name": "Primordial Memory: Toxin",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Inflict Arg1 plural:Arg1|stack|stacks of Poison on all enemies. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0058",
        "kind": "posse",
        "name": "Primordial Memory: Spike",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Gain Arg1 plural:Arg1|stack|stacks of Temporary Counter. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0059",
        "kind": "posse",
        "name": "Primordial Memory: Might",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Gain Arg1 STR. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0060",
        "kind": "posse",
        "name": "Primordial Memory: Bastion",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Gain Arg1 Shield. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      },
      {
        "id": "posse-0061",
        "kind": "posse",
        "name": "Primordial Memory: Fury",
        "lineupToken": null,
        "assets": {
          "thumb": "./generated-assets/posse/Icon/KeyToken_Skill_00.webp",
          "full": "./generated-assets/posse/FullArt/KeyToken_Crystal_00.webp"
        },
        "description": "Gain Arg1 Temporary DMG Amplification. Scaling guide: Primordia Mastery Scaling",
        "aliases": [],
        "searchTags": [],
        "selectable": false,
        "realm": "OTHER",
        "acquisitionSource": null
      }
    ]
  }
}
